import { Button } from '@progress/kendo-react-buttons'
import { ComboBox, DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from '@progress/kendo-react-form'

import {
  MouseEvent as ReactMouseEvent,
  useEffect,
  useLayoutEffect,
  useState
} from 'react'

import { Input } from '@progress/kendo-react-inputs'
import {
  del,
  get,
  post,
  postFormData,
  put
} from '../../services/utils'
import { useEntidadeStore } from '../../stores/entidade'
import styles from '../../styles/classificadores/ConsultarClassificadoresForm.module.scss'
import { Dialog } from '@progress/kendo-react-dialogs'
import {
  ACAO_ESTADO_TABLE_NAME,
  ACAO_CONTRATACAO_TABLE_NAME,
  ACAO_TIPO_ENGENHARIA_TABLE_NAME,
  ACAO_TIPO_NATUREZA_TABLE_NAME,
  ACAO_COMPONENTE_TABLE_NAME,
  ACAO_TIPO_PLANEAMENTO_TABLE_NAME,
  AG_DECISAO_TABLE_NAME,
  AG_ESTADO_TABLE_NAME,
  AG_TEMA_TABLE_NAME,
  AG_TIPO_PRETENSAO_TABLE_NAME,
  CANDIDATURA_ESTADO_TABLE_NAME,
  CANDIDATURA_INSTRUMENTO_FINANCIAMENTO_TABLE_NAME,
  CONSULTAR_ENTIDADES,
  DELETE_ACAO_ESTADO,
  DELETE_ACAO_CONTRATACAO,
  DELETE_ACAO_TIPO_ENGENHARIA,
  DELETE_ACAO_TIPO_NATUREZA,
  DELETE_ACAO_COMPONENTE,
  DELETE_ACAO_TIPO_PLANEAMENTO,
  DELETE_AG_DECISAO,
  DELETE_AG_ESTADO,
  DELETE_AG_TEMA,
  DELETE_AG_TIPO_PRETENSAO,
  DELETE_CANDIDATURA_ESTADO,
  DELETE_CANDIDATURA_INSTRUMENTO_FINANCIAMENTO,
  DELETE_DH_CONDICIONANTES_PROCESSO,
  DELETE_DH_FASES_PROCEDIMENTO_DELIMITACAO,
  DELETE_DH_LOCALIZACAO_PROCESSO,
  DELETE_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA,
  DELETE_DH_TIPO_ACAO_JUDICIAL,
  DELETE_DH_TIPO_AQUISICAO,
  DELETE_DH_TIPO_DOMINIO,
  DELETE_DH_TIPO_INICIATIVA,
  DELETE_DH_TIPO_LINHA_DEMARCACAO,
  DELETE_DH_TIPO_PROCESSO,
  DELETE_DH_TIPO_SENTENCA,
  DELETE_DH_TIPO_ACAO_RECONHECIMENTOS,
  DELETE_DH_RECURSO,
  DELETE_DH_DECISAO_FINAL,
  DELETE_DI_TIPO_ENTIDADE,
  DELETE_DO_ESTADO,
  DELETE_DO_TIPO_ACESSO,
  DELETE_DO_TIPO_RECURSO,
  DELETE_EA_ESTADO,
  DELETE_INT_ESTADO,
  DELETE_INT_INSTUMENTO_PLANEAMENTO_ESTADO,
  DELETE_INT_PRIORIDADE,
  DELETE_INT_TIPOS_PLANEAMENTO_ESTADO,
  DELETE_INT_TIPO_INCIDENCIA,
  DELETE_INT_TIPO_MOBILIZACAO,
  DELETE_INT_PALXXI_TIPO_NIVEL1,
  DELETE_INT_PALXXI_TIPO_NIVEL2,
  DELETE_INT_PALXXI_TIPO_NIVEL3,
  DELETE_INT_INSTRUMENTOS_PLANEAMENTOS,
  DELETE_INT_ACAO_FONTE_FINANCIAMENTO,
  DELETE_MOB_OBJETIVO_NIVEL1,
  DELETE_MOB_OBJETIVO_NIVEL2,
  DELETE_MOB_TIPO_MANCHA_EMPRESTIMO,
  DELETE_MOBILIZACAO_ESTADO,
  DELETE_MODELO_TIPO,
  DELETE_MO_ESTADO,
  DELETE_MO_MODELO_SUBTIPO,
  DELETE_OC_ESTADO,
  DELETE_PROCESSO_ESTADO,
  DELETE_TIPO_INTERVENCAO,
  DELETE_US_TIPO_PROCESSO,
  DELETE_US_TIPO_TITULO,
  DELETE_US_TIPO_UTILIZACAO,
  DELETE_US_TITULO_ESTADO,
  DH_CONDICIONANTES_PROCESSO_TABLE_NAME,
  DH_ESTADO_PROCESSO_TABLE_NAME,
  DH_FASES_PROCEDIMENTO_DELIMITACAO_TABLE_NAME,
  DH_LOCALIZACAO_PROCESSO_TABLE_NAME,
  DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA_TABLE_NAME,
  DH_TIPO_ACAO_RECONHECIMENTO_TABLE_NAME,
  DH_TIPO_ACAO_JUDICIAL_TABLE_NAME,
  DH_TIPO_AQUISICAO_TABLE_NAME,
  DH_TIPO_DOMINIO_TABLE_NAME,
  DH_TIPO_INICIATIVA,
  DH_TIPO_LINHA_DEMARCACAO_TABLE_NAME,
  DH_TIPO_PROCESSO_TABLE_NAME,
  DH_TIPO_SENTENCA_TABLE_NAME,
  DH_TIPO_RECURSO_TABLE_NAME,
  DH_DECISAO_FINAL_TABLE_NAME,
  DI_TIPO_ENTIDADE_TABLE_NAME,
  DO_ESTADO_TABLE_NAME,
  DO_TIPO_ACESSO_TABLE_NAME,
  DO_TIPO_RECURSO_TABLE_NAME,
  EA_ESTADO_TABLE_NAME,
  GET_AG_DECISAO,
  GET_AG_TEMA_ASYNC,
  GET_AG_TIPO_PRETENSAO,
  GET_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA,
  GET_DH_TIPO_ACAO_RECONHECIMENTOS,
  GET_DH_TIPO_DOMINIO,
  GET_EA_ESTADO,
  GET_ESTADOS_OCORRENCIA,
  GET_ESTADO_MOBILIZACAO,
  GET_INT_INSTRUMENTO_PLANEAMENTO_ESTADO,
  GET_INT_PLANEAMENTO_1,
  GET_INT_PLANEAMENTO_2,
  GET_INT_PLANEAMENTO_3,
  GET_INT_TIPO_INTERVENCAO,
  GET_INT_TIPO_MOBILIZACAO,
  GET_INT_PALXXI_TIPO_NIVEL1,
  GET_INT_PALXXI_TIPO_NIVEL2,
  GET_INT_PALXXI_TIPO_NIVEL3,
  GET_INT_INSTRUMENTO_PLANEAMENTO,
  GET_INT_ACAO_FONTE_FINANCIAMENTO,
  GET_MOB_OBJETIVO_NIVEL1,
  GET_MOB_OBJETIVO_NIVEL2,
  GET_MOB_TIPO_MANCHA_EMPRESTIMO,
  GET_MO_ESTADO,
  GET_TIPO_INCIDENCIA,
  GET_TIPO_LINHA_DEMARCACAO,
  GET_US_ESTADO_TITULO,
  INSERT_ACAO_ESTADO,
  INSERT_ACAO_CONTRATACAO,
  INSERT_ACAO_TIPO_ENGENHARIA,
  INSERT_ACAO_TIPO_NATUREZA,
  INSERT_ACAO_COMPONENTE,
  INSERT_ACAO_TIPO_PLANEAMENTO,
  INSERT_AG_DECISAO,
  INSERT_AG_ESTADO,
  INSERT_AG_TEMA,
  INSERT_AG_TIPO_PRETENSAO,
  INSERT_CANDIDATURA_ESTADO,
  INSERT_CANDIDATURA_INSTRUMENTO_FINANCIAMENTO,
  INSERT_DH_CONDICIONANTES_PROCESSO,
  INSERT_DH_FASE_PROCEDIMENTO,
  INSERT_DH_LOCALIZACAO_PROCESSO,
  INSERT_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA,
  INSERT_DH_TIPO_ACAO_RECONHECIMENTOS,
  INSERT_DH_TIPO_RECURSO,
  INSERT_DH_DECISAO_FINAL,
  INSERT_DH_TIPO_ACAO_JUDICIAL,
  INSERT_DH_TIPO_AQUISICAO,
  INSERT_DH_TIPO_DOMINIO,
  INSERT_DH_TIPO_INICIATIVA,
  INSERT_DH_TIPO_LINHA_DEMARCACAO,
  INSERT_DH_TIPO_PROCESSO,
  INSERT_DH_TIPO_SENTENÇA,
  INSERT_DI_TIPO_ENTIDADE,
  INSERT_DO_ESTADO,
  INSERT_DO_TIPO_ACESSO,
  INSERT_DO_TIPO_RECURSO,
  INSERT_EA_ESTADO,
  INSERT_INSTRUMENTO_PLANEAMENTO_ESTADO,
  INSERT_INT_ESTADO,
  INSERT_INT_PLANEAMENTO_1,
  INSERT_INT_PLANEAMENTO_2,
  INSERT_INT_PLANEAMENTO_3,
  INSERT_INT_PRIORIDADE,
  INSERT_INT_TIPO_INCIDENCIA,
  INSERT_INT_TIPO_INTERVENCAO,
  INSERT_INT_TIPO_MOBILIZACAO,
  INSERT_INT_PALXXI_TIPO_NIVEL1,
  INSERT_INT_PALXXI_TIPO_NIVEL2,
  INSERT_INT_PALXXI_TIPO_NIVEL3,
  INSERT_INT_INSTRUMENTO_PLANEAMENTO,
  UPDATE_INT_INSTRUMENTO_PLANEAMENTO,
  INSERT_INT_ACAO_FONTE_FINANCIAMENTO,
  UPDATE_INT_ACAO_FONTE_FINANCIAMENTO,
  INSERT_MOB_OBJETIVO_NIVEL1,
  INSERT_MOB_OBJETIVO_NIVEL2,
  INSERT_MOB_TIPO_MANCHA_EMPRESTIMO,
  INSERT_MOBILIZACAO_ESTADO,
  INSERT_MODELO_TIPO,
  INSERT_MO_ESTADO,
  INSERT_MO_SUBTIPO_MODELO,
  INSERT_OC_ESTADO,
  INSERT_PROCESSO_ESTADO,
  INSERT_US_TIPO_PROCESSO,
  INSERT_US_TIPO_TITULO,
  INSERT_US_TIPO_UTILIZACAO,
  INSERT_US_TITULO_ESTADO,
  INT_ESTADO_TABLE_NAME,
  INT_INSTRUMENTO_PLANEAMENTO_ESTADO_TABLE_NAME,
  INT_PLANEAMENTO_NIVEL_1_TABLE_NAME,
  INT_PRIORIDADE_TABLE_NAME,
  INT_TIPO_INCIDENCIA_TABLE_NAME,
  INT_TIPO_INTERVENCAO_TABLE_NAME,
  INT_TIPO_MOBILIZACAO_TABLE_NAME,
  INT_PALXXI_TIPO_NIVEL1_TABLE_NAME,
  INT_PALXXI_TIPO_NIVEL2_TABLE_NAME,
  INT_PALXXI_TIPO_NIVEL3_TABLE_NAME,
  INT_INSTRUMENTO_PLANEAMENTO_TABLE_NAME,
  INT_ACAO_FONTE_FINANCIAMENTO_TABLE_NAME,
  MOB_OBJETIVO_NIVEL1_TABLE_NAME,
  MOB_OBJETIVO_NIVEL2_TABLE_NAME,
  MOB_TIPO_MANCHA_EMPRESTIMO_TABLE_NAME,
  MOBILIZACAO_ESTADO_TABLE_NAME,
  MO_ESTADO_TABLE_NAME,
  MO_MODELOS_TIPO_TABLE_NAME,
  MO_MODELO_SUBTIPO_TABLE_NAME,
  GV_TEMA_TABLE_NAME,
  GV_SUB_TEMA_TABLE_NAME,
  GV_TEMA_SUB_TEMA_TABLE_NAME,
  INT_EMAIL_USERS_INSERT,
  INT_EMAIL_USERS_UPDATE,
  OC_ESTADO_TABLE_NAME,
  PESQUISAR_ACAO_ESTADO,
  PESQUISAR_CONDICIONANTES_PROCESSO,
  PESQUISAR_ESTADO,
  PESQUISAR_ESTADO_CANDIDATURA,
  PESQUISAR_ESTADO_INSTRUMENTO_FINANCIAMENTO,
  PESQUISAR_ESTADO_INTERVENCOES,
  PESQUISAR_ESTADO_PROCESSO,
  PESQUISAR_FASE_PROCEDIMENTO_DE_ELIMINACAO,
  PESQUISAR_LOCALIZACAO_PROCESSO,
  PESQUISAR_MO_MODELO_SUBTIPOS,
  PESQUISAR_MO_MODELO_TIPOS,
  PESQUISAR_PRIORIDADE,
  PESQUISAR_TIPOACESSO,
  PESQUISAR_TIPOENTIDADE,
  PESQUISAR_TIPORECURSO,
  PESQUISAR_TIPO_AQUISICAO,
  PESQUISAR_TIPO_INICIATIVA,
  PESQUISAR_TIPO_JUDICIAL,
  PESQUISAR_TIPO_PROCESSO,
  PESQUISAR_TIPO_SENTENCA,
  PESQUISAR_US_TIPO_PROCESSO,
  PESQUISAR_US_TIPO_TITULO,
  PESQUISAR_US_TIPO_UTILIZACAO,
  UPDATE_ACAO_ESTADO,
  UPDATE_ACAO_CONTRATACAO,
  UPDATE_ACAO_TIPO_ENGENHARIA,
  UPDATE_ACAO_TIPO_NATUREZA,
  UPDATE_ACAO_COMPONENTE,
  UPDATE_ACAO_TIPO_PLANEAMENTO,
  UPDATE_AG_DECISAO,
  UPDATE_AG_TEMA,
  UPDATE_AG_TIPO_PRETENSAO,
  UPDATE_CANDIDATURA_ESTADO,
  UPDATE_CANDIDATURA_INSTRUMENTO_FINANCIAMENTO,
  UPDATE_DH_CONDICIONANTES_PROCESSO,
  UPDATE_DH_FASE_PROCEDIMENTO,
  UPDATE_DH_LOCALIZACAO_PROCESSO,
  UPDATE_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA,
  UPDATE_DH_TIPO_ACAO_RECONHECIMENTOS,
  UPDATE_DH_TIPO_RECURSO,
  UPDATE_DH_DECISAO_FINAL,
  UPDATE_DH_SITUACAO_NOTIFICACAO,
  UPDATE_DH_TIPO_ACAO_JUDICIAL,
  UPDATE_DH_TIPO_AQUISICAO,
  UPDATE_DH_TIPO_DOMINIO,
  UPDATE_DH_TIPO_INICIATIVA,
  UPDATE_DH_TIPO_LINHA_DEMARCACAO,
  UPDATE_DH_TIPO_PROCESSO,
  UPDATE_DH_TIPO_SENTEÇA,
  UPDATE_DI_TIPO_ENTIDADE,
  UPDATE_DO_ESTADO,
  UPDATE_DO_TIPO_ACESSO,
  UPDATE_DO_TIPO_RECURSO,
  UPDATE_EA_ESTADO,
  UPDATE_INSTRUMENTO_PLANEAMENTO_ESTADO,
  UPDATE_INT_ESTADO,
  UPDATE_INT_PLANEAMENTO_1,
  UPDATE_INT_PLANEAMENTO_2,
  UPDATE_INT_PLANEAMENTO_3,
  UPDATE_INT_PRIORIDADE,
  UPDATE_INT_TIPO_INCIDENCIA,
  UPDATE_INT_TIPO_INTERVENCAO,
  UPDATE_INT_TIPO_MOBILIZACAO,
  UPDATE_INT_PALXXI_TIPO_NIVEL1,
  UPDATE_INT_PALXXI_TIPO_NIVEL2,
  UPDATE_INT_PALXXI_TIPO_NIVEL3,
  UPDATE_MOB_OBJETIVO_NIVEL1,
  UPDATE_MOB_OBJETIVO_NIVEL2,
  UPDATE_MOB_TIPO_MANCHA_EMPRESTIMO,
  UPDATE_MOBILIZACAO_ESTADO,
  UPDATE_MODELO_TIPO,
  UPDATE_MO_ESTADO,
  UPDATE_MO_SUBTIPO_MODELO,
  UPDATE_OC_ESTADO,
  UPDATE_PROCESSO_ESTADO,
  UPDATE_US_TIPO_PROCESSO,
  UPDATE_US_TIPO_TITULO,
  UPDATE_US_TIPO_UTILIZACAO,
  UPDATE_US_TITULO_ESTADO,
  US_ESTADO_TITULO_TABLE_NAME,
  US_TIPO_PROCESSO_TABLE_NAME,
  US_TIPO_TITULO_TABLE_NAME,
  US_TIPO_UTILIZACAO_TABLE_NAME,
  GET_SPECIFIC_COLUMNS_MO_SUBTIPO,
  MDT_SELECTION_NAME,
  GET_MDTS,
  UPLOAD_MDT,
  DELETE_MDT,
  PROCESS_MDT,
  INSERT_MDT,
  GET_MDT,
  URL_AJUDA_BACKOFFICE_CLASSIFICADORES,
  MDT_NAME_EXISTS,
  UPDATE_MDT,
  GET_ALL_GV_TEMAS,
  UPDATE_GV_TEMAS,
  DELETE_GV_TEMAS,
  INSERT_GV_TEMAS,
  GET_ALL_GV_SUBTEMAS,
  INSERT_GV_SUBTEMAS,
  UPDATE_GV_SUBTEMAS,
  DELETE_GV_SUBTEMAS,
  DELETE_GV_SUB_TEMAS,
  GET_ALL_GV_SUB_TEMAS,
  INSERT_GV_SUB_TEMAS,
  UPDATE_GV_SUB_TEMAS,
  GET_GV_PESQUISA_ID_SUB_TEMAS,
  GET_MOB_OBJETIVO_NIVEL_1_BY_ID,
  GET_INT_PALXXI_TIPO_NIVEL_1_BY_ID,
  GET_INT_PALXXI_TIPO_NIVEL_2_BY_ID,
  PESQUISAR_ACAO_ESTADO_POR_PERFIL,
  GET_ACAO_TIPO_ENGENHARIA,
  GET_ACAO_CONTRATACAO,
  GET_ACAO_TIPO_NATUREZA,
  GET_ACAO_COMPONENTE,
  GET_ACAO_TIPO_PLANEAMENTO,
  GET_DH_TIPO_RECURSO,
  GET_DH_DECISAO_FINAL
} from '../../utils/constants'

import { elementoClickMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { useCommonStore } from '../../stores/common'
import { Upload, UploadOnProgressEvent, UploadOnRemoveEvent } from '@progress/kendo-react-upload'
import { DateTimePicker } from '@progress/kendo-react-dateinputs'

type Props = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
}

type GetAllTemasResult = { id: number; descricao: string }
type GetAllMobObjetivoNivel1Result = { id: number; descricao: string }
type GetAllIntPalXXITipoNivel1Result = { id: number; descricao: string }
type GetAllIntPalXXITipoNivel2Result = { id: number; descricao: string }

interface GvTema {
  id: number;
  descricao: string;
  // Adicione outros campos conforme necessário
}


export default function ConsultarClassificadoresForm({ onCloseClick }: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const getEntidades = async (data: any) => await post<any, any>(`${CONSULTAR_ENTIDADES}`, data)
  const [tipoPesquisaVisible, setTipoPesquisaVisible] = useState(true)
  const [criterioGeograficoVisible, setCriterioGeograficoVisible] = useState(false)
  const [localizacaoVisible, setLocalizacaoVisible] = useState(false)
  const [entidadeVisible, setEntidadeVisible] = useState(false)
  const [data, setData] = useState([{"": "Selecione o classificador"}]);
  const [showDialog, setShowDialog] = useState(false);
  const toggleMaximizeView = useCommonStore((state) => state.toggleMaximizeView)
  const [idField, setIdField] = useState<any>();
  const [designacaoField, setDesignacaoField] = useState<any>();
  const [descricaoField, setDescricaoField] = useState<any>();
  const [siglaField, setSiglaField] = useState<any>();
  const [nomeField, setNomeField] = useState<any>();
  const [showPesquisar, setShowPesquisar] = useState<any>(true);
  const [showGravar, setShowGravar] = useState<any>();
  const [tabelaClassificador, setTabelaClassificador] = useState<any>();
  const [novoRegisto, setNovoRegisto] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showUserId, setShowUserId] = useState(false);
  const [emailField, setEmailField] = useState<any>();
  const [userIdField, setUserIdField] = useState<any>();
  const [showUploadDocumentos, setShowUploadDocumentos] = useState(false);
  const [fileField, setFileField] = useState<any>();
  const [descricaoDisabled, setDescricaoDisabled] = useState(false);
  const [siglaDisabled, setSiglaDisabled] = useState(false);
  const [gravarDisabled, setGravarDisabled] = useState(false);
  const [showTipo, setShowTipo] = useState(false);
  const [showDataVoo, setshowDataVoo] = useState(false);
  const [nomeDisabled, setNomeDisabled] = useState(false);
  const [tipoField, setTipoField] = useState<any>();
  const [dataField, setDataField] = useState<any>();
  const [densidadeField, setDensidadeField] = useState<any>();
  const [gvTemaField, setGvTemaField] = useState<any>(null);
  const [mobObjetivoNivel1Field, setMobObjetivoNivel1Field] = useState<any>(null);
  const [intPalXXITipoNivel1Field, setintPalXXITipoNivel1Field] = useState<any>(null);
  const [intPalXXITipoNivel2Field, setintPalXXITipoNivel2Field] = useState<any>(null);
  const [allTemas, setAllTemas] = useState<any[]>([]);

  const toggletipoPesquisa = () => {
    setTipoPesquisaVisible(!tipoPesquisaVisible)
  }
  const togglecriterioGeografico = () => {
    setCriterioGeograficoVisible(!criterioGeograficoVisible)
  }
  const toggleLocalizacao = () => {
    setLocalizacaoVisible(!localizacaoVisible)
  }
  const toogleEntidade = () => {
    setEntidadeVisible(!entidadeVisible)
  }

  const selectEntidadeResult = useEntidadeStore(
    (state) => state.selectEntidadeResult
  )

  const getOcEstados = async () => await get<any>(`${GET_ESTADOS_OCORRENCIA}`);
  const getMoModeloTipos = async () => await get<any>(`${PESQUISAR_MO_MODELO_TIPOS}`);
  const updateModeloTipo = async (data: any) => await put<any, any>(`${UPDATE_MODELO_TIPO}`, data);
  const insertModeloTipo = async (data: any) => await post<any, any>(`${INSERT_MODELO_TIPO}`, data);
  const updateOcEstado = async (data: any) => await put<any, any>(`${UPDATE_OC_ESTADO}`, data);
  const insertOcEstado = async (data: any) => await post<any, any>(`${INSERT_OC_ESTADO}`, data);
  const updateMoEstado = async (data: any) => await put<any, any>(`${UPDATE_MO_ESTADO}`, data);
  const insertMoEstado = async (data: any) => await post<any, any>(`${INSERT_MO_ESTADO}`, data);
  const getMoEstado = async () => await get<any>(`${GET_MO_ESTADO}`);
  const updateIntEstado = async (data: any) => await put<any, any>(`${UPDATE_INT_ESTADO}`, data);
  const insertIntEstado = async (data: any) => await post<any, any>(`${INSERT_INT_ESTADO}`, data);
  const getIntEstado = async () => await get<any>(`${PESQUISAR_ESTADO_INTERVENCOES}`);
  const updateAcaoEstado = async (data: any) => await put<any, any>(`${UPDATE_ACAO_ESTADO}`, data);
  const insertAcaoEstado = async (data: any) => await post<any, any>(`${INSERT_ACAO_ESTADO}`, data);
  const getAcaoEstado = async () => await get<any>(`${PESQUISAR_ACAO_ESTADO_POR_PERFIL}`);
  const updateAcaoContratacao = async (data: any) => await put<any, any>(`${UPDATE_ACAO_CONTRATACAO}`, data);
  const insertAcaoContratacao = async (data: any) => await post<any, any>(`${INSERT_ACAO_CONTRATACAO}`, data);
  const getAcaoContratacao = async () => await get<any, any>(`${GET_ACAO_CONTRATACAO}`);
  const updateAcaoTipoEngenharia = async (data: any) => await put<any, any>(`${UPDATE_ACAO_TIPO_ENGENHARIA}`, data);
  const insertAcaoTipoEngenharia = async (data: any) => await post<any, any>(`${INSERT_ACAO_TIPO_ENGENHARIA}`, data);
  const getAcaoTipoEngenharia = async () => await get<any, any>(`${GET_ACAO_TIPO_ENGENHARIA}`);
  const updateAcaoTipoNatureza = async (data: any) => await put<any, any>(`${UPDATE_ACAO_TIPO_NATUREZA}`, data);
  const insertAcaoTipoNatureza = async (data: any) => await post<any, any>(`${INSERT_ACAO_TIPO_NATUREZA}`, data);
  const getAcaoTipoNatureza = async () => await get<any, any>(`${GET_ACAO_TIPO_NATUREZA}`);
  const updateAcaoComponente = async (data: any) => await put<any, any>(`${UPDATE_ACAO_COMPONENTE}`, data);
  const insertAcaoComponente = async (data: any) => await post<any, any>(`${INSERT_ACAO_COMPONENTE}`, data);
  const getAcaoComponente = async () => await get<any, any>(`${GET_ACAO_COMPONENTE}`);
  const updateAcaoTipoPlaneamento = async (data: any) => await put<any, any>(`${UPDATE_ACAO_TIPO_PLANEAMENTO}`, data);
  const insertAcaoTipoPlaneamento = async (data: any) => await post<any, any>(`${INSERT_ACAO_TIPO_PLANEAMENTO}`, data);
  const getAcaoTipoPlaneamento = async () => await get<any, any>(`${GET_ACAO_TIPO_PLANEAMENTO}`);
  const updateMobilizacaoEstado = async (data: any) => await put<any, any>(`${UPDATE_MOBILIZACAO_ESTADO}`, data);
  const insertMobilizacaoEstado = async (data: any) => await post<any, any>(`${INSERT_MOBILIZACAO_ESTADO}`, data);
  const getMobilizacaoEstado = async () => await get<any>(`${GET_ESTADO_MOBILIZACAO}`);
  const updateCandidaturaEstado = async (data: any) => await put<any, any>(`${UPDATE_CANDIDATURA_ESTADO}`, data);
  const insertCandidaturaEstado = async (data: any) => await post<any, any>(`${INSERT_CANDIDATURA_ESTADO}`, data);
  const getCandidaturaEstado = async () => await get<any>(`${PESQUISAR_ESTADO_CANDIDATURA}`);
  const updateCandidaturaInstrumentoFinanciamento = async (data: any) => await put<any, any>(`${UPDATE_CANDIDATURA_INSTRUMENTO_FINANCIAMENTO}`, data);
  const insertCandidaturaInstrumentoFinanciamento = async (data: any) => await post<any, any>(`${INSERT_CANDIDATURA_INSTRUMENTO_FINANCIAMENTO}`, data);
  const getCandidaturaInstrumentoFinanciamento = async () => await get<any>(`${PESQUISAR_ESTADO_INSTRUMENTO_FINANCIAMENTO}`);
  const updateDhEstadoProcesso = async (data: any) => await put<any, any>(`${UPDATE_PROCESSO_ESTADO}`, data);
  const insertDhEstadoProcesso = async (data: any) => await post<any, any>(`${INSERT_PROCESSO_ESTADO}`, data);
  const getEstadoProcesso = async () => await get<any>(`${PESQUISAR_ESTADO_PROCESSO}`);
  const updateUsTituloEstado= async (data: any) => await put<any, any>(`${UPDATE_US_TITULO_ESTADO}`, data);
  const insertUsTituloEstado = async (data: any) => await post<any, any>(`${INSERT_US_TITULO_ESTADO}`, data);
  const getUsEstadoTitulo = async () => await get<any>(`${GET_US_ESTADO_TITULO}`);
  const updateAgEstado= async (data: any) => await put<any, any>(`${UPDATE_US_TITULO_ESTADO}`, data);
  const insertAgEstado = async (data: any) => await post<any, any>(`${INSERT_AG_ESTADO}`, data);
  const getAgEstado = async () => await get<any>(`${GET_EA_ESTADO}`);
  const updateEaEstado= async (data: any) => await put<any, any>(`${UPDATE_EA_ESTADO}`, data);
  const insertEaEstado = async (data: any) => await post<any, any>(`${INSERT_EA_ESTADO}`, data);
  const getDoEstado = async () => await get<any>(`${PESQUISAR_ESTADO}`);
  const updateDoEstado= async (data: any) => await put<any, any>(`${UPDATE_DO_ESTADO}`, data);
  const insertDoEstado = async (data: any) => await post<any, any>(`${INSERT_DO_ESTADO}`, data);
  const getIntPlaneamento1 = async () => await get<any>(`${GET_INT_PLANEAMENTO_1}`);
  const updateIntPlaneamento1= async (data: any) => await put<any, any>(`${UPDATE_INT_PLANEAMENTO_1}`, data);
  const insertIntPlaneamento1 = async (data: any) => await post<any, any>(`${INSERT_INT_PLANEAMENTO_1}`, data);
  const getIntPlaneamento2 = async () => await get<any>(`${GET_INT_PLANEAMENTO_2}`);
  const updateIntPlaneamento2= async (data: any) => await put<any, any>(`${UPDATE_INT_PLANEAMENTO_2}`, data);
  const insertIntPlaneamento2 = async (data: any) => await post<any, any>(`${INSERT_INT_PLANEAMENTO_2}`, data);
  const getIntPlaneamento3 = async () => await get<any>(`${GET_INT_PLANEAMENTO_3}`);
  const updateIntPlaneamento3= async (data: any) => await put<any, any>(`${UPDATE_INT_PLANEAMENTO_3}`, data);
  const insertIntPlaneamento3 = async (data: any) => await post<any, any>(`${INSERT_INT_PLANEAMENTO_3}`, data);
  const getIntPrioridade = async () => await get<any>(`${PESQUISAR_PRIORIDADE}`);
  const updateIntPrioridade= async (data: any) => await put<any, any>(`${UPDATE_INT_PRIORIDADE}`, data);
  const insertIntPrioridade = async (data: any) => await post<any, any>(`${INSERT_INT_PRIORIDADE}`, data);
  const getIntTipoIntervencao = async () => await get<any>(`${GET_INT_TIPO_INTERVENCAO}`);
  const insertIntTipoIntervencao= async (data: any) => await post<any, any>(`${INSERT_INT_TIPO_INTERVENCAO}`, data);
  const updateIntTipoIntervencao = async (data: any) => await put<any, any>(`${UPDATE_INT_TIPO_INTERVENCAO}`, data);
  const getIntIntrumentoPlaneamentoEstado = async () => await get<any>(`${GET_INT_INSTRUMENTO_PLANEAMENTO_ESTADO}`);
  const insertIntInstrumentoPlaneamentoEstado= async (data: any) => await post<any, any>(`${INSERT_INSTRUMENTO_PLANEAMENTO_ESTADO}`, data);
  const updateIntInstrumentoPlaneamentoEstado = async (data: any) => await put<any, any>(`${UPDATE_INSTRUMENTO_PLANEAMENTO_ESTADO}`, data);
  const getIntTipoIncidencia = async () => await get<any>(`${GET_TIPO_INCIDENCIA}`);
  const insertIntTipoIncidencia= async (data: any) => await post<any, any>(`${INSERT_INT_TIPO_INCIDENCIA}`, data);
  const updateIntTipoIncidencia = async (data: any) => await put<any, any>(`${UPDATE_INT_TIPO_INCIDENCIA}`, data);
  const getIntTipoMobilizacao = async () => await get<any>(`${GET_INT_TIPO_MOBILIZACAO}`);
  const insertIntTipoMobilizacao= async (data: any) => await post<any, any>(`${INSERT_INT_TIPO_MOBILIZACAO}`, data);
  const updateIntTipoMobilizacao = async (data: any) => await put<any, any>(`${UPDATE_INT_TIPO_MOBILIZACAO}`, data);
  const getIntPalXXITipoNivel1 = async () => await get<any>(`${GET_INT_PALXXI_TIPO_NIVEL1}`);
  const insertIntPalXXITipoNivel1 = async (data: any) => await post<any, any>(`${INSERT_INT_PALXXI_TIPO_NIVEL1}`, data);
  const updateIntPalXXITipoNivel1 = async (data: any) => await put<any, any>(`${UPDATE_INT_PALXXI_TIPO_NIVEL1}`, data);
  const getIntPalXXITipoNivel2 = async () => await get<any>(`${GET_INT_PALXXI_TIPO_NIVEL2}`);
  const insertIntPalXXITipoNivel2 = async (data: any) => await post<any, any>(`${INSERT_INT_PALXXI_TIPO_NIVEL2}`, data);
  const updateIntPalXXITipoNivel2 = async (data: any) => await put<any, any>(`${UPDATE_INT_PALXXI_TIPO_NIVEL2}`, data);
  const getIntPalXXITipoNivel3 = async () => await get<any>(`${GET_INT_PALXXI_TIPO_NIVEL3}`);
  const insertIntPalXXITipoNivel3 = async (data: any) => await post<any, any>(`${INSERT_INT_PALXXI_TIPO_NIVEL3}`, data);
  const updateIntPalXXITipoNivel3 = async (data: any) => await put<any, any>(`${UPDATE_INT_PALXXI_TIPO_NIVEL3}`, data);
  const getIntInstrumentoPlaneamento = async () => await get<any>(`${GET_INT_INSTRUMENTO_PLANEAMENTO}`);
  const insertIntInstrumentoPlaneamento = async (data: any) => await post<any, any>(`${INSERT_INT_INSTRUMENTO_PLANEAMENTO}`, data);
  const updateIntInstrumentoPlaneamento = async (data: any) => await put<any, any>(`${UPDATE_INT_INSTRUMENTO_PLANEAMENTO}`, data);
  const getIntAcaoFonteFinanciamento = async () => await get<any>(`${GET_INT_ACAO_FONTE_FINANCIAMENTO}`);
  const insertIntAcaoFonteFinanciamento = async (data: any) => await post<any, any>(`${INSERT_INT_ACAO_FONTE_FINANCIAMENTO}`, data);
  const updateIntAcaoFonteFinanciamento = async (data: any) => await put<any, any>(`${UPDATE_INT_ACAO_FONTE_FINANCIAMENTO}`, data);
  const insertMobObjetivoNivel1 = async (data: any) => await post<any, any>(`${INSERT_MOB_OBJETIVO_NIVEL1}`, data);
  const updateMobObjetivoNivel1 = async (data: any) => await post<any, any>(`${UPDATE_MOB_OBJETIVO_NIVEL1}`, data);
  const getMobObjetivoNivel1 = async () => await get<any>(`${GET_MOB_OBJETIVO_NIVEL1}`);
  const insertMobObjetivoNivel2 = async (data: any) => await post<any, any>(`${INSERT_MOB_OBJETIVO_NIVEL2}`, data);
  const updateMobObjetivoNivel2 = async (data: any) => await post<any, any>(`${UPDATE_MOB_OBJETIVO_NIVEL2}`, data);
  const getMobObjetivoNivel2 = async () => await get<any>(`${GET_MOB_OBJETIVO_NIVEL2}`);
  const insertMobTipoManchaEmprestimo = async (data: any) => await post<any, any>(`${INSERT_MOB_TIPO_MANCHA_EMPRESTIMO}`, data);
  const updateMobTipoManchaEmprestimo = async (data: any) => await post<any, any>(`${UPDATE_MOB_TIPO_MANCHA_EMPRESTIMO}`, data);
  const getMobTipoManchaEmprestimo = async () => await get<any>(`${GET_MOB_TIPO_MANCHA_EMPRESTIMO}`);
  const insertDhTipoProcesso= async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_PROCESSO}`, data);
  const updateDhTipoProcesso = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_PROCESSO}`, data);
  const getDhTipoProcesso = async () => await get<any>(`${PESQUISAR_TIPO_PROCESSO}`);
  const getDhEstadoProcesso = async () => await get<any>(`${PESQUISAR_ESTADO_PROCESSO}`);
  const insertDhFasesProcedimento= async (data: any) => await post<any, any>(`${INSERT_DH_FASE_PROCEDIMENTO}`, data);
  const updateDhFasesProcedimento = async (data: any) => await put<any, any>(`${UPDATE_DH_FASE_PROCEDIMENTO}`, data);
  const getDhFasesProcedimento= async () => await get<any>(`${PESQUISAR_FASE_PROCEDIMENTO_DE_ELIMINACAO}`);
  const updateDhTipoDominio = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_DOMINIO}`, data);
  const insertDhTipoDominio= async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_DOMINIO}`, data);
  const getDhTipoDominio = async () => await get<any>(`${GET_DH_TIPO_DOMINIO}`);
  const updateDhLocalizacaoProcesso = async (data: any) => await put<any, any>(`${UPDATE_DH_LOCALIZACAO_PROCESSO}`, data);
  const insertDhLocalizacaoProcesso= async (data: any) => await post<any, any>(`${INSERT_DH_LOCALIZACAO_PROCESSO}`, data);
  const getDhLocalizacaoProcesso = async () => await get<any>(`${PESQUISAR_LOCALIZACAO_PROCESSO}`);
  const updateDhTipoSenteça = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_SENTEÇA}`, data);
  const insertDhTipoSentença = async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_SENTENÇA}`, data);
  const getDhTipoSentença = async () => await get<any>(`${PESQUISAR_TIPO_SENTENCA}`);
  const updateDhCondicionantesProcesso = async (data: any) => await put<any, any>(`${UPDATE_DH_CONDICIONANTES_PROCESSO}`, data);
  const insertDhCondicionantesProcesso = async (data: any) => await post<any, any>(`${INSERT_DH_CONDICIONANTES_PROCESSO}`, data);
  const getDhCondicionantesProcesso = async () => await get<any>(`${PESQUISAR_CONDICIONANTES_PROCESSO}`);  const updateDhTipoAcaoJudicial = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_ACAO_JUDICIAL}`, data);
  const insertDhTipoAcaoJudicial = async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_ACAO_JUDICIAL}`, data);
  const getDhTipoAcaoJudicial = async () => await get<any>(`${PESQUISAR_TIPO_JUDICIAL}`);
  const updateDhTipoAquisicao = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_AQUISICAO}`, data);
  const insertDHTipoAquisicao = async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_AQUISICAO}`, data);
  const getDhTipoAquisicao = async () => await get<any>(`${PESQUISAR_TIPO_AQUISICAO}`);
  const updateDhReconhecimentoPropriedadePrivada = async (data: any) => await put<any, any>(`${UPDATE_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA}`, data);
  const insertDhReconhecimentoPropriedadePrivada = async (data: any) => await post<any, any>(`${INSERT_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA}`, data);
  const getDhReconhecimentoPropriedadePrivada = async () => await get<any>(`${GET_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA}`);
  const updateDhTipoAcaoReconhecimentos = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_ACAO_RECONHECIMENTOS}`, data);
  const insertDhTipoAcaoReconhecimentos = async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_ACAO_RECONHECIMENTOS}`, data);
  const getDhTipoAcaoReconhecimentos = async () => await get<any>(`${GET_DH_TIPO_ACAO_RECONHECIMENTOS}`);
  const updateDhTipoRecurso = async (data: any) => await get<any>(`${UPDATE_DH_TIPO_RECURSO}`);
  const insertDhTipoRecurso = async (data: any) => await get<any>(`${INSERT_DH_TIPO_RECURSO}`);
  const getDhTipoRecurso = async () => await get<any>(`${GET_DH_TIPO_RECURSO}`);
  const updateDhTipoDecisaoFinal = async (data: any) => await get<any>(`${UPDATE_DH_DECISAO_FINAL}`);
  const insertDhTipoDecisaoFinal = async (data: any) => await get<any>(`${INSERT_DH_DECISAO_FINAL}`);
  const getDhTipoDecisaoFinal = async () => await get<any>(`${GET_DH_DECISAO_FINAL}`);
  const updateDhtipoIniciativa = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_INICIATIVA}`, data);
  const insertDhTipoIniciativa = async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_INICIATIVA}`, data);
  const getDhTipoIniciativa = async () => await get<any>(`${PESQUISAR_TIPO_INICIATIVA}`);
  const updateDhTipoLinhaDemarcacao = async (data: any) => await put<any, any>(`${UPDATE_DH_TIPO_LINHA_DEMARCACAO}`, data);
  const insertDhTipoLinhaDemarcacao = async (data: any) => await post<any, any>(`${INSERT_DH_TIPO_LINHA_DEMARCACAO}`, data);
  const getDhTipoLinhaDemarcacao = async () => await get<any>(`${GET_TIPO_LINHA_DEMARCACAO}`);
  const updateUsTipoProcesso = async (data: any) => await put<any, any>(`${UPDATE_US_TIPO_PROCESSO}`, data);
  const insertUsTipoProcesso = async (data: any) => await post<any, any>(`${INSERT_US_TIPO_PROCESSO}`, data);
  const getUsTipoProcesso = async () => await get<any>(`${PESQUISAR_US_TIPO_PROCESSO}`);
  const updateUsTipoTitulo = async (data: any) => await put<any, any>(`${UPDATE_US_TIPO_TITULO}`, data);
  const insertUsTipoTitulo = async (data: any) => await post<any, any>(`${INSERT_US_TIPO_TITULO}`, data);
  const getUsTipoTitulo = async () => await get<any>(`${PESQUISAR_US_TIPO_TITULO}`);
  const updateUsTipoUtilizacao = async (data: any) => await put<any, any>(`${UPDATE_US_TIPO_UTILIZACAO}`, data);
  const insertUsTipoUtilizacao = async (data: any) => await post<any, any>(`${INSERT_US_TIPO_UTILIZACAO}`, data);
  const getUsTipoUtilizacao = async () => await get<any>(`${PESQUISAR_US_TIPO_UTILIZACAO}`);
  const updateAgTipoPretensao = async (data: any) => await put<any, any>(`${UPDATE_AG_TIPO_PRETENSAO}`, data);
  const insertAgTipoPretensao = async (data: any) => await post<any, any>(`${INSERT_AG_TIPO_PRETENSAO}`, data);
  const getAgTipoPretensao = async () => await get<any>(`${GET_AG_TIPO_PRETENSAO}`);
  const updateAgDecisao = async (data: any) => await put<any, any>(`${UPDATE_AG_DECISAO}`, data);
  const insertAgDecisao = async (data: any) => await post<any, any>(`${INSERT_AG_DECISAO}`, data);
  const getAgDecisao = async () => await get<any>(`${GET_AG_DECISAO}`);
  const updateAgTema = async (data: any) => await put<any, any>(`${UPDATE_AG_TEMA}`, data);
  const insertAgTema = async (data: any) => await post<any, any>(`${INSERT_AG_TEMA}`, data);
  const getAgtema = async () => await get<any>(`${GET_AG_TEMA_ASYNC}`);
  const updateDiTipoEntidade = async (data: any) => await put<any, any>(`${UPDATE_DI_TIPO_ENTIDADE}`, data);
  const insertDiTipoEntidade = async (data: any) => await post<any, any>(`${INSERT_DI_TIPO_ENTIDADE}`, data);
  const getDiTipoEntidade = async () => await get<any>(`${PESQUISAR_TIPOENTIDADE}`);
  const updateDoTipoAcesso = async (data: any) => await put<any, any>(`${UPDATE_DO_TIPO_ACESSO}`, data);
  const insertDoTipoAcesso = async (data: any) => await post<any, any>(`${INSERT_DO_TIPO_ACESSO}`, data);
  const getDoTipoAcesso = async () => await get<any>(`${PESQUISAR_TIPOACESSO}`);
  const updateDoTipoRecurso = async (data: any) => await put<any, any>(`${UPDATE_DO_TIPO_RECURSO}`, data);
  const insertDoTipoRecurso = async (data: any) => await post<any, any>(`${INSERT_DO_TIPO_RECURSO}`, data);
  const getDoTipoRecurso = async () => await get<any>(`${PESQUISAR_TIPORECURSO}`);

  const getGvTema = async () => await get<any>(`${GET_ALL_GV_TEMAS}`);
  const updateGvTema = async (data: any) => await put<any, any>(`${UPDATE_GV_TEMAS}`, data);
  const insertGvTema = async (data: any) => await post<any, any>(`${INSERT_GV_TEMAS}`, data);
  const deleteGvTema = (id: number) => del(`${DELETE_GV_TEMAS}/${id}`, {})

  const getGv_SubTema = async () => await get<any>(`${GET_ALL_GV_SUBTEMAS}`);
  const updateGv_SubTema = async (data: any) => await put<any, any>(`${UPDATE_GV_SUBTEMAS}`, data);
  const insertGv_SubTema = async (data: any) => await post<any, any>(`${INSERT_GV_SUBTEMAS}`, data);
  const deleteGv_SubTema = (id: number) => del(`${DELETE_GV_SUBTEMAS}/${id}`, {})

  //  TABELA ASSOCIATIVA SUBTEMAS
  const insertAssociacaoSubTema = async (data: any) => await post<any, any>(`${INSERT_GV_SUB_TEMAS}`, data);
  const updateAssociacaoSubTema = async (data: any) => await put<any, any>(`${UPDATE_GV_SUB_TEMAS}`, data);
  const deleteAssociacaoSubTema = (id: number) => del(`${DELETE_GV_SUB_TEMAS}/${id}`, {})

  const getGvTema_SubTema = async () => await get<any>(`${GET_ALL_GV_SUB_TEMAS}`);
  const updateGvTema_SubTema = async (data: any) => await put<any, any>(`${UPDATE_GV_SUB_TEMAS}`, data);
  const insertGvTema_SubTema = async (data: any) => await post<any, any>(`${INSERT_GV_SUB_TEMAS}`, data);
  const deleteGvTema_SubTema = (id: number) => del(`${DELETE_GV_SUB_TEMAS}/${id}`, {})

  const updateMoSubTipoModelo= async (data: any) => await put<any, any>(`${UPDATE_MO_SUBTIPO_MODELO}`, data);
  const insertMoSubTipoModelo = async (data: any) => await post<any, any>(`${INSERT_MO_SUBTIPO_MODELO}`, data);
  const getMoSubtipoModelo = async () => await get<any>(`${PESQUISAR_MO_MODELO_SUBTIPOS}`);
  const deleteModeloTipo = (id: number) => del(`${DELETE_MODELO_TIPO}/${id}`, {})
  const deleteOcorrenciaEstado = (id: number) => del(`${DELETE_OC_ESTADO}/${id}`, {})
  const deleteMoEstado = (id: number) => del(`${DELETE_MO_ESTADO}/${id}`, {})
  const deleteIntEstado = (id: number) => del(`${DELETE_INT_ESTADO}/${id}`, {})
  const deleteAcaoEstado = (id: number) => del(`${DELETE_ACAO_ESTADO}/${id}`, {})
  const deleteAcaoContratacao = (id: number) => del(`${DELETE_ACAO_CONTRATACAO}/${id}`, {})
  const deleteAcaoTipoEngenharia = (id: number) => del(`${DELETE_ACAO_TIPO_ENGENHARIA}/${id}`, {})
  const deleteAcaoTipoNatureza = (id: number) => del(`${DELETE_ACAO_TIPO_NATUREZA}/${id}`, {})
  const deleteAcaoComponente = (id: number) => del(`${DELETE_ACAO_COMPONENTE}/${id}`, {})
  const deleteAcaoTipoPlaneamento = (id: number) => del(`${DELETE_ACAO_TIPO_PLANEAMENTO}/${id}`, {})
  const deleteMobilizacaoEstado = (id: number) => del(`${DELETE_MOBILIZACAO_ESTADO}/${id}`, {})
  const deleteCandidaturaEstado = (id: number) => del(`${DELETE_CANDIDATURA_ESTADO}/${id}`, {})
  const deleteCandidaturaInstrumentoFinanciamento = (id: number) => del(`${DELETE_CANDIDATURA_INSTRUMENTO_FINANCIAMENTO}/${id}`, {})
  const deleteProcessoEstado = (id: number) => del(`${DELETE_PROCESSO_ESTADO}/${id}`, {})
  const deleteUsEstadoTitulo = (id: number) => del(`${DELETE_US_TITULO_ESTADO}/${id}`, {})
  const deleteAgEstado = (id: number) => del(`${DELETE_AG_ESTADO}/${id}`, {})
  const deleteEaEstado = (id: number) => del(`${DELETE_EA_ESTADO}/${id}`, {})
  const deleteDoEstado = (id: number) => del(`${DELETE_DO_ESTADO}/${id}`, {})
  const deleteIntPlaneamento = (id: number) => del(`${DELETE_INT_TIPOS_PLANEAMENTO_ESTADO}/${id}`, {})
  const deleteIntPrioridade = (id: number) => del(`${DELETE_INT_PRIORIDADE}/${id}`, {})
  const deleteIntTipoIntervencao = (id: number) => del(`${DELETE_TIPO_INTERVENCAO}/${id}`, {})
  const deleteIntInstrumentosPlaneamentosEstados = (id: number) => del(`${DELETE_INT_INSTUMENTO_PLANEAMENTO_ESTADO}/${id}`, {})
  const deleteIntTipoIncidencia= (id: number) => del(`${DELETE_INT_TIPO_INCIDENCIA}/${id}`, {})
  const deleteIntTipoMobilizacao= (id: number) => del(`${DELETE_INT_TIPO_MOBILIZACAO}/${id}`, {})
  const deleteIntPALXXITipo1= (id: number) => del(`${DELETE_INT_PALXXI_TIPO_NIVEL1}/${id}`, {})
  const deleteIntPALXXITipo2= (id: number) => del(`${DELETE_INT_PALXXI_TIPO_NIVEL2}/${id}`, {})
  const deleteIntPALXXITipo3= (id: number) => del(`${DELETE_INT_PALXXI_TIPO_NIVEL3}/${id}`, {})
  const deleteIntInstrumentosPlaneamentos = (id: number) => del(`${DELETE_INT_INSTRUMENTOS_PLANEAMENTOS}/${id}`, {})
  const deleteIntFonteFinanciamento = (id: number) => del(`${DELETE_INT_ACAO_FONTE_FINANCIAMENTO}/${id}`, {})
  const deleteMobObjetivoNivel1 = (id: number) => del(`${DELETE_MOB_OBJETIVO_NIVEL1}/${id}`, {})
  const deleteMobObjetivoNivel2 = (id: number) => del(`${DELETE_MOB_OBJETIVO_NIVEL2}/${id}`, {})
  const deleteMobTipoManchaEmprestimo = (id: number) => del(`${DELETE_MOB_TIPO_MANCHA_EMPRESTIMO}/${id}`, {})
  const deleteDhTipoProcesso= (id: number) => del(`${DELETE_DH_TIPO_PROCESSO}/${id}`, {})
  const deleteDhEstadoProcesso = (id: number) => del(`${DELETE_PROCESSO_ESTADO}/${id}`, {})
  const deleteDhFasesProdecimentoDelimitacao= (id: number) => del(`${DELETE_DH_FASES_PROCEDIMENTO_DELIMITACAO}/${id}`, {})
  const deleteDhTipoDominio= (id: number) => del(`${DELETE_DH_TIPO_DOMINIO}/${id}`, {})
  const deleteDhLocalizacaoProcesso= (id: number) => del(`${DELETE_DH_LOCALIZACAO_PROCESSO}/${id}`, {})
  const deleteDhTipoSentenca= (id: number) => del(`${DELETE_DH_TIPO_SENTENCA}/${id}`, {})
  const deleteDhTipoAcaoReconhecimentos = (id: number) => del(`${DELETE_DH_TIPO_ACAO_RECONHECIMENTOS}/${id}`, {})
  const deleteDhTipoRecurso = (id: number) => del(`${DELETE_DH_RECURSO}/${id}`, {})
  const deleteDhTipoDecisaoFinal = (id: number) => del(`${DELETE_DH_DECISAO_FINAL}/${id}`, {})
  const deleteDhConcicionantesProcesso= (id: number) => del(`${DELETE_DH_CONDICIONANTES_PROCESSO}/${id}`, {})
  const deleteDhTipoAcaoJudicial= (id: number) => del(`${DELETE_DH_TIPO_ACAO_JUDICIAL}/${id}`, {})
  const deleteDhTipoAquisicao= (id: number) => del(`${DELETE_DH_TIPO_AQUISICAO}/${id}`, {})
  const deleteDhReconhecimentoProprieidadePrivada= (id: number) => del(`${DELETE_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA}/${id}`, {})
  const deleteDhTipoIniciativa= (id: number) => del(`${DELETE_DH_TIPO_INICIATIVA}/${id}`, {})
  const deleteDhTipoLinhaDemarcacao= (id: number) => del(`${DELETE_DH_TIPO_LINHA_DEMARCACAO}/${id}`, {})
  const deleteUsTipoProcesso= (id: number) => del(`${DELETE_US_TIPO_PROCESSO}/${id}`, {})
  const deleteUsTipoTitulo= (id: number) => del(`${DELETE_US_TIPO_TITULO}/${id}`, {})
  const deleteUsTipoUtilizacao= (id: number) => del(`${DELETE_US_TIPO_UTILIZACAO}/${id}`, {})
  const deleteAgTipoPretensao= (id: number) => del(`${DELETE_AG_TIPO_PRETENSAO}/${id}`, {})
  const deleteAgDecisao= (id: number) => del(`${DELETE_AG_DECISAO}/${id}`, {})
  const deleteAgTema= (id: number) => del(`${DELETE_AG_TEMA}/${id}`, {})
  const deleteDiTipoEntidade= (id: number) => del(`${DELETE_DI_TIPO_ENTIDADE}/${id}`, {})
  const deleteDoTipoAcesso= (id: number) => del(`${DELETE_DO_TIPO_ACESSO}/${id}`, {})
  const deleteDoTipoRecurso= (id: number) => del(`${DELETE_DO_TIPO_RECURSO}/${id}`, {})
  const deleteMoModeloSubTipo= (id: number) => del(`${DELETE_MO_MODELO_SUBTIPO}/${id}`, {})
  const insertEmailUsersList = async (data: any) => await post<any, any>(`${INT_EMAIL_USERS_INSERT}`, data);
  const updateEmailUsersList = async (data: any) => await put<any, any>(`${INT_EMAIL_USERS_UPDATE}`, data);
  const getSpecificColumnsMoSubTipo = async () => await get<any>(GET_SPECIFIC_COLUMNS_MO_SUBTIPO);
  const getMDTs = async () => get<any>(GET_MDTS); 
  const getMDT = async (id: any) => get<any>(`${GET_MDT}/${id}`);
  const uploadMdt = async (data: any) => await postFormData<any, any>(`${UPLOAD_MDT}`, data);
  const deleteMdt = async(id: number) => await del(`${DELETE_MDT}/${id}`, {});
  const processMdt = async (data: any) => await post<any, any>(`${PROCESS_MDT}`, data);
  const insertMdt = async(data: any) => await post<any, any>(INSERT_MDT, data);
  const mdtNameExists = async(data: any) => await post<any, any>(MDT_NAME_EXISTS, data);
  const updateMdt = async(data: any) => await post<any, any>(UPDATE_MDT, data);

  const remover = async (e: any) => {
    setShowDialog(false);
    switch (tabelaClassificador) {
        case OC_ESTADO_TABLE_NAME:
            await deleteOcorrenciaEstado(idField);
            break;
        case MO_ESTADO_TABLE_NAME:
            await deleteMoEstado(idField);
            break;
        case MO_MODELOS_TIPO_TABLE_NAME:
            await deleteModeloTipo(idField);
            break;
        case INT_ESTADO_TABLE_NAME:
            await deleteIntEstado(idField);
            break;
        case ACAO_ESTADO_TABLE_NAME:
            await deleteAcaoEstado(idField);
            break;
        case ACAO_CONTRATACAO_TABLE_NAME:
            await deleteAcaoContratacao(idField);
            break;
        case ACAO_TIPO_ENGENHARIA_TABLE_NAME:
            await deleteAcaoTipoEngenharia(idField);
            break;
        case ACAO_TIPO_NATUREZA_TABLE_NAME:
            await deleteAcaoTipoNatureza(idField);
            break;
        case ACAO_COMPONENTE_TABLE_NAME:
            await deleteAcaoComponente(idField);
            break;
        case ACAO_TIPO_PLANEAMENTO_TABLE_NAME:
            await deleteAcaoTipoPlaneamento(idField);
            break;
        case MOBILIZACAO_ESTADO_TABLE_NAME:
            await deleteMobilizacaoEstado(idField);
            break;
        case CANDIDATURA_ESTADO_TABLE_NAME:
            await deleteCandidaturaEstado(idField);
            break;
        case CANDIDATURA_INSTRUMENTO_FINANCIAMENTO_TABLE_NAME:
            await deleteCandidaturaInstrumentoFinanciamento(idField);
            break;
        case DH_ESTADO_PROCESSO_TABLE_NAME:
            await deleteProcessoEstado(idField);
            break;
        case US_ESTADO_TITULO_TABLE_NAME:
            await deleteUsEstadoTitulo(idField);
            break;
        case AG_ESTADO_TABLE_NAME:
            await deleteAgEstado(idField);
            break;
        case EA_ESTADO_TABLE_NAME:
            await deleteEaEstado(idField);
            break;
        case DO_ESTADO_TABLE_NAME:
            await deleteDoEstado(idField);
            break;
        case INT_PLANEAMENTO_NIVEL_1_TABLE_NAME:
            await deleteIntPlaneamento(idField);
            break;
        case INT_PRIORIDADE_TABLE_NAME:
            await deleteIntPrioridade(idField);
            break;
        case INT_TIPO_INTERVENCAO_TABLE_NAME:
            await deleteIntTipoIntervencao(idField);
            break;
        case INT_INSTRUMENTO_PLANEAMENTO_ESTADO_TABLE_NAME:
            await deleteIntInstrumentosPlaneamentosEstados(idField);
            break;
        case INT_TIPO_INCIDENCIA_TABLE_NAME:
            await deleteIntTipoIncidencia(idField);
            break;
        case INT_TIPO_MOBILIZACAO_TABLE_NAME:
            await deleteIntTipoMobilizacao(idField);
            break;
        case INT_PALXXI_TIPO_NIVEL1_TABLE_NAME:
            await deleteIntPALXXITipo1(idField);
            break;
        case INT_PALXXI_TIPO_NIVEL2_TABLE_NAME:
            await deleteIntPALXXITipo2(idField);
            break;
        case INT_PALXXI_TIPO_NIVEL3_TABLE_NAME:
            await deleteIntPALXXITipo3(idField);
            break;
        case INT_INSTRUMENTO_PLANEAMENTO_TABLE_NAME:
            await deleteIntInstrumentosPlaneamentos(idField);
            break;
        case INT_ACAO_FONTE_FINANCIAMENTO_TABLE_NAME:
            await deleteIntFonteFinanciamento(idField);
            break;
        case MOB_OBJETIVO_NIVEL1_TABLE_NAME:
            await deleteMobObjetivoNivel1(idField);
            break;
        case MOB_OBJETIVO_NIVEL2_TABLE_NAME:
            await deleteMobObjetivoNivel2(idField);
            break;
        case MOB_TIPO_MANCHA_EMPRESTIMO_TABLE_NAME:
            await deleteMobTipoManchaEmprestimo(idField);
            break;
        case DH_TIPO_PROCESSO_TABLE_NAME:
            await deleteDhTipoProcesso(idField);
            break;
        case DH_FASES_PROCEDIMENTO_DELIMITACAO_TABLE_NAME:
            await deleteDhFasesProdecimentoDelimitacao(idField);
            break;
        case DH_TIPO_DOMINIO_TABLE_NAME:
            await deleteDhTipoDominio(idField);
            break;
        case DH_LOCALIZACAO_PROCESSO_TABLE_NAME:
            await deleteDhLocalizacaoProcesso(idField);
            break;
        case DH_TIPO_SENTENCA_TABLE_NAME:
            await deleteDhTipoSentenca(idField);
            break;
        case DH_TIPO_ACAO_RECONHECIMENTO_TABLE_NAME:
            await deleteDhTipoAcaoReconhecimentos(idField);
            break;
        case DH_TIPO_RECURSO_TABLE_NAME:
            await deleteDhTipoRecurso(idField);
            break;
        case DH_DECISAO_FINAL_TABLE_NAME:
            await deleteDhTipoDecisaoFinal(idField);
            break;
        case DH_CONDICIONANTES_PROCESSO_TABLE_NAME:
            await deleteDhConcicionantesProcesso(idField);
            break;
        case DH_TIPO_ACAO_JUDICIAL_TABLE_NAME:
            await deleteDhTipoAcaoJudicial(idField);
            break;
        case DH_TIPO_AQUISICAO_TABLE_NAME:
            await deleteDhTipoAquisicao(idField);
            break;
        case DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA_TABLE_NAME:
            await deleteDhReconhecimentoProprieidadePrivada(idField);
            break;
        case DH_TIPO_INICIATIVA:
            await deleteDhTipoIniciativa(idField);
            break;
        case DH_TIPO_LINHA_DEMARCACAO_TABLE_NAME:
            await deleteDhTipoLinhaDemarcacao(idField);
            break;
        case US_TIPO_PROCESSO_TABLE_NAME:
            await deleteUsTipoProcesso(idField);
            break;
        case US_TIPO_TITULO_TABLE_NAME:
            await deleteUsTipoTitulo(idField);
            break;
        case US_TIPO_UTILIZACAO_TABLE_NAME:
            await deleteUsTipoUtilizacao(idField);
            break;
        case AG_TIPO_PRETENSAO_TABLE_NAME:
            await deleteAgTipoPretensao(idField);
            break;
        case AG_DECISAO_TABLE_NAME:
            await deleteAgDecisao(idField);
            break;
        case AG_TEMA_TABLE_NAME:
            await deleteAgTema(idField);
            break;
        case DI_TIPO_ENTIDADE_TABLE_NAME:
            await deleteDiTipoEntidade(idField);
            break;
        case DO_TIPO_ACESSO_TABLE_NAME:
            await deleteDoTipoAcesso(idField);
            break;
        case DO_TIPO_RECURSO_TABLE_NAME:
            await deleteDoTipoRecurso(idField);
            break;
        case MO_MODELO_SUBTIPO_TABLE_NAME:
            await deleteMoModeloSubTipo(idField);
            break;
        case GV_TEMA_TABLE_NAME:
          await deleteGvTema(idField)
          break; 
        case GV_SUB_TEMA_TABLE_NAME:
          await deleteAssociacaoSubTema(idField)
          break;
        case MDT_SELECTION_NAME:
          await deleteMdt(idField);
          break;
        default:
    }
    refreshGrid(tabelaClassificador);
}
  useEffect(() => {
    setShowGravar(false);
    setShowPesquisar(true);
  }, []);

  const handleSubmit = async (e: any) => {
    setTabelaClassificador(e.values?.tipoClassificador?.tabela);
    refreshGrid(e.values?.tipoClassificador?.tabela);
  }

  const [showDescricao , setShowDescricao] = useState(false);
  const [showDesignacao , setShowDesignacao] = useState(false);
  const [showSigla , setShowSigla] = useState(false);
  const [showNome , setShowNome] = useState(false);
  const [showGvSubTema, setShowGvSubTema] = useState(false);
  const [showMobObjetivoNivel1, setMobObjetivoNivel1] = useState(false);
  const [showIntPalXXITipoNivel1, setIntPalXXITipoNivel1] = useState(false);
  const [showIntPalXXITipoNivel2, setIntPalXXITipoNivel2] = useState(false);
  const [showRenderizaNovoRegisto, setShowRenderizaNovoRegisto] = useState(false);

  const [classificadores, setClassificadores] = useState<any[]>();
  const [GvTemaData, setGvTemaData] = useState<GetAllTemasResult[]>([])
  const [MobObjetivoNivel1Data, setMobObjetivoNivel1Data] = useState<GetAllMobObjetivoNivel1Result[]>([])
  const [IntPalXXITipoNivel1Data, setIntPalXXITipoNivel1Data] = useState<GetAllIntPalXXITipoNivel1Result[]>([])
  const [IntPalXXITipoNivel2Data, setIntPalXXITipoNivel2Data] = useState<GetAllIntPalXXITipoNivel2Result[]>([])

  const classificadoresConst: any[] = [
    {
      tabela: OC_ESTADO_TABLE_NAME,
      descricao: "Ocorrencias - Estado"
    },
    {
      tabela: MO_ESTADO_TABLE_NAME,
      descricao: "Modelos - Estado"
    },
    {
      tabela: MO_MODELOS_TIPO_TABLE_NAME,
      descricao: "Modelos - Tipo"
    }, 
    {
      tabela: INT_ESTADO_TABLE_NAME,
      descricao: "Intervenção - Estado"
    },
    {
      tabela: ACAO_ESTADO_TABLE_NAME,
      descricao: "Ação - Estado"
    },
    {
      tabela: ACAO_CONTRATACAO_TABLE_NAME,
      descricao: "Ação - Procedimento de contratação"
    },
    {
      tabela: ACAO_TIPO_ENGENHARIA_TABLE_NAME,
      descricao: "Ação - Tipo de Engenharia"
    },
    {
      tabela: ACAO_TIPO_NATUREZA_TABLE_NAME,
      descricao: "Ação - Natureza da ação"
    },
    {
      tabela: ACAO_COMPONENTE_TABLE_NAME,
      descricao: "Ação - Componentes da ação"
    },
        {
      tabela: ACAO_TIPO_PLANEAMENTO_TABLE_NAME,
      descricao: "Ação - Tipo de planeamento"
    },
    {
      tabela: MOBILIZACAO_ESTADO_TABLE_NAME,
      descricao: "Mobilização - Estado"
    },
    {
      tabela: CANDIDATURA_ESTADO_TABLE_NAME,
      descricao: "Candidatura - Estado"
    },
    {
      tabela: CANDIDATURA_INSTRUMENTO_FINANCIAMENTO_TABLE_NAME,
      descricao: "Candidatura - Instrumentos de financiamento"
    },
    {
      tabela: DH_ESTADO_PROCESSO_TABLE_NAME,
      descricao: "Processo - Estado"
    },
    {
      tabela: US_ESTADO_TITULO_TABLE_NAME,
      descricao: "Uso de Solo - Estado"
    },
    {
      tabela: AG_ESTADO_TABLE_NAME,
      descricao: "Apoio á gestão - Estado"
    },
    {
      tabela: EA_ESTADO_TABLE_NAME,
      descricao: "Estrategia de Adaptação - Estado"
    },
    {
      tabela: DO_ESTADO_TABLE_NAME,
      descricao: "Documento - Estado"
    },
    {
      tabela: INT_PLANEAMENTO_NIVEL_1_TABLE_NAME,
      descricao: "Intervenção - Planeamento Tipo Nível 1"
    },
    {
      tabela: INT_PRIORIDADE_TABLE_NAME,
      descricao: "Intervenção - Prioridade"
    }, 
    {
      tabela: INT_TIPO_INTERVENCAO_TABLE_NAME,
      descricao: "Intervenção - Tipo Intervenção"
    }, 
    {
      tabela: INT_INSTRUMENTO_PLANEAMENTO_ESTADO_TABLE_NAME,
      descricao: "Intervenção - Instrumento Planeamento Estados"
    },
    {
      tabela: INT_TIPO_INCIDENCIA_TABLE_NAME,
      descricao: "Intervenção - Tipo Incidência"
    },
    {
      tabela: INT_TIPO_MOBILIZACAO_TABLE_NAME,
      descricao: "Mobilização - Tipo Mobilização"
    },
    {
      tabela: INT_PALXXI_TIPO_NIVEL1_TABLE_NAME,
      descricao: "Intervenção - Tipologia Nível 1 (PAL XXI)"
    },
    {
      tabela: INT_PALXXI_TIPO_NIVEL2_TABLE_NAME,
      descricao: "Intervenção - Tipologia Nível 2 (PAL XXI)"
    },
    {
      tabela: INT_PALXXI_TIPO_NIVEL3_TABLE_NAME,
      descricao: "Intervenção - Tipologia Nível 3 (PAL XXI)"
    },
    {
      tabela: INT_INSTRUMENTO_PLANEAMENTO_TABLE_NAME,
      descricao: "Intervenção - Instrumento de Planeamento"
    },
    {
      tabela: INT_ACAO_FONTE_FINANCIAMENTO_TABLE_NAME,
      descricao: "Intervenção - Fonte de Financiamento"
    },
    {
      tabela: MOB_OBJETIVO_NIVEL1_TABLE_NAME,
      descricao: "Mobilização - Objetivo Deposição Nível 1"
    },
    {
      tabela: MOB_OBJETIVO_NIVEL2_TABLE_NAME,
      descricao: "Mobilização - Objetivo Deposição Nível 2"
    },
    {
      tabela: MOB_TIPO_MANCHA_EMPRESTIMO_TABLE_NAME,
      descricao: "Mobilização - Tipo de mancha de empréstimo"
    },
    {
      tabela: DH_TIPO_PROCESSO_TABLE_NAME,
      descricao: "Domínio Hidrico - Tipo Processo"
    },
        {
      tabela: DH_ESTADO_PROCESSO_TABLE_NAME,
      descricao: "Domínio Hidrico - Estado Processo"
    },
    {
      tabela: DH_LOCALIZACAO_PROCESSO_TABLE_NAME,
      descricao: "Domínio Hidrico - Localização Processo"
    },
        {
      tabela: DH_CONDICIONANTES_PROCESSO_TABLE_NAME,
      descricao: "Domínio Hidrico - Condicionantes Processo"
    },
    {
      tabela: DH_FASES_PROCEDIMENTO_DELIMITACAO_TABLE_NAME,
      descricao: "Domínio Hidrico - Fases de Procedimento Delimitação"
    },
    {
      tabela: DH_TIPO_DOMINIO_TABLE_NAME,
      descricao: "Domínio Hidrico - Tipo Domínio"
    },
    {
      tabela: DH_TIPO_SENTENCA_TABLE_NAME,
      descricao: "Domínio Hidrico - Tipo Sentença"
    },  
    {
      tabela: DH_TIPO_ACAO_JUDICIAL_TABLE_NAME,
      descricao: "Domínio Hidrico - Tipo Ação Judicial"
    },
    {
      tabela: DH_TIPO_AQUISICAO_TABLE_NAME,
      descricao: "Domínio Hidrico - Tipo Aquisição"
    },
    {
      tabela: DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA_TABLE_NAME,
      descricao: "Domínio Hidrico - Reconhecimento Propriedade Privada"
    },
    {
      tabela: DH_TIPO_ACAO_RECONHECIMENTO_TABLE_NAME,
      descricao: "Domínio Hidrico - Reconhecimento Propriedade Privada (Ação Reconhecimento)"
    },
    {
      tabela: DH_TIPO_RECURSO_TABLE_NAME,
      descricao: "Domínio Hidrico - Recurso"
    },
    {
      tabela: DH_DECISAO_FINAL_TABLE_NAME,
      descricao: "Domínio Hidrico - Decisão Final"
    },
    {
      tabela: DH_TIPO_INICIATIVA,
      descricao: "Domínio Hidrico - Tipo Iniciativa"
    },  
    {
      tabela: DH_TIPO_LINHA_DEMARCACAO_TABLE_NAME,
      descricao: "Domínio Hidrico - Tipo Linha Demarcação"
    },
    {
      tabela: US_TIPO_PROCESSO_TABLE_NAME,
      descricao: "Uso de Solo - Tipo de Processo"
    },
    {
      tabela: US_TIPO_TITULO_TABLE_NAME,
      descricao: "Uso de Solo - Tipo de Título"
    },
    {
      tabela: US_TIPO_UTILIZACAO_TABLE_NAME,
      descricao: "Uso de Solo - Tipo de Utilização"
    },
    {
      tabela: AG_TIPO_PRETENSAO_TABLE_NAME,
      descricao: "Apoio à Gestão - Tipo Pretensão"
    },
    {
      tabela: AG_DECISAO_TABLE_NAME,
      descricao: "Apoio à Gestão - Decisao"
    },
    {
      tabela: AG_TEMA_TABLE_NAME,
      descricao: "Apoio à Gestão - Tema"
    },
    {
      tabela: DI_TIPO_ENTIDADE_TABLE_NAME,
      descricao: "Entidade - Tipo Entidade"
    },
    {
      tabela: DO_TIPO_ACESSO_TABLE_NAME,
      descricao: "Documentos - Tipo Acesso"
    },
    {
      tabela: DO_TIPO_RECURSO_TABLE_NAME,
      descricao: "Documentos - Tipo Recurso"
    },
    {
      tabela: MO_MODELO_SUBTIPO_TABLE_NAME,
      descricao: "Modelos - SubTipo"
    },
    {
      tabela: GV_TEMA_TABLE_NAME,
      descricao: "Geovisualizadores - Tema"
    },
    {
      tabela: GV_SUB_TEMA_TABLE_NAME,
      descricao: "Geovisualizadores - SubTema"
    },
    {
      tabela: MDT_SELECTION_NAME,
      descricao: "MDTs - Calculo de perfis geograficos"
    }
   
  ]

  useEffect(() => {
    setClassificadores(classificadoresConst.sort((a, b) => a.descricao.localeCompare(b.descricao)));
  }, []);

  useEffect(() => {
    const getGvTemaData = async () => {
        const allTemasResult = await get<GetAllTemasResult[]>(GET_ALL_GV_TEMAS);
        if (allTemasResult) setGvTemaData(allTemasResult);
    };

    const getMobObjetivoNivel1Data = async () => {
      const allMobObjetivoNivel1Result = await get<GetAllMobObjetivoNivel1Result[]>(GET_MOB_OBJETIVO_NIVEL1);
        if (allMobObjetivoNivel1Result) setMobObjetivoNivel1Data(allMobObjetivoNivel1Result);
    }

    const getIntPalXXITipoNivel1Data = async () => {
      const allIntPalXXITipoNivel1Result = await get<GetAllMobObjetivoNivel1Result[]>(GET_INT_PALXXI_TIPO_NIVEL1);
        if (allIntPalXXITipoNivel1Result) setIntPalXXITipoNivel1Data(allIntPalXXITipoNivel1Result);
    }

    const getIntPalXXITipoNivel2Data = async () => {
      const allIntPalXXITipoNivel2Result = await get<GetAllMobObjetivoNivel1Result[]>(GET_INT_PALXXI_TIPO_NIVEL2);
        if (allIntPalXXITipoNivel2Result) setIntPalXXITipoNivel2Data(allIntPalXXITipoNivel2Result);
    }

    getGvTemaData();
    getMobObjetivoNivel1Data();
    getIntPalXXITipoNivel1Data();
    getIntPalXXITipoNivel2Data();
  }, []);

  const hideAll = () => {
    setShowUploadDocumentos(false);
    setShowDesignacao(false);
    setShowSigla(false);
    setShowNome(false)
    setShowDescricao(false);
    setShowUserId(false);
    setShowEmail(false);
    setDescricaoDisabled(false);
    setSiglaDisabled(false);
    setGravarDisabled(false);
    setshowDataVoo(false);
    setShowTipo(false);
    setshowDataVoo(false);
    setNomeDisabled(false);
    setShowGvSubTema(false);
    setMobObjetivoNivel1(false);
    setIntPalXXITipoNivel1(false);
    setIntPalXXITipoNivel2(false);
  }

  const refreshGrid = async (tabelaClassificadorLocal: any) => {
    postMessage({ type: 'showLoader' }, '*')
    let result: any = [];
    setTabelaClassificador(tabelaClassificadorLocal);
    hideAll();
    if (tabelaClassificadorLocal == OC_ESTADO_TABLE_NAME) {
      result = await getOcEstados();
      setShowDescricao(true)
      setShowDesignacao(true)
    }
    else if (tabelaClassificadorLocal == MO_ESTADO_TABLE_NAME) {
      result = await getMoEstado();
      setShowDescricao(true)
      setShowDesignacao(true)
    } else if (tabelaClassificadorLocal == MO_MODELOS_TIPO_TABLE_NAME) {
      result =await getMoModeloTipos();
      setShowDescricao(true)
      setShowDesignacao(true)
    } else if (tabelaClassificadorLocal == INT_ESTADO_TABLE_NAME) {
      setShowDescricao(true)
      result =await getIntEstado();
    } else if (tabelaClassificadorLocal == ACAO_ESTADO_TABLE_NAME) {
      result =await getAcaoEstado();
      setShowDescricao(true)
      } else if (tabelaClassificadorLocal == ACAO_CONTRATACAO_TABLE_NAME) {
      result =await getAcaoContratacao();
      setShowDescricao(true)
      } else if (tabelaClassificadorLocal == ACAO_TIPO_ENGENHARIA_TABLE_NAME) {
      result =await getAcaoTipoEngenharia();
      setShowDescricao(true)
      } else if (tabelaClassificadorLocal == ACAO_TIPO_NATUREZA_TABLE_NAME) {
      result =await getAcaoTipoNatureza();
      setShowDescricao(true)
      } else if (tabelaClassificadorLocal == ACAO_COMPONENTE_TABLE_NAME) {
      result =await getAcaoComponente();
      setShowDescricao(true)
      } else if (tabelaClassificadorLocal == ACAO_TIPO_PLANEAMENTO_TABLE_NAME) {
      result =await getAcaoTipoPlaneamento();
      setShowDescricao(true)
    } else if (tabelaClassificadorLocal == MOBILIZACAO_ESTADO_TABLE_NAME) {
      result =await getMobilizacaoEstado();
      setShowDescricao(true)
    } else if (tabelaClassificadorLocal == CANDIDATURA_ESTADO_TABLE_NAME) {
      result =await getCandidaturaEstado();
    } else if (tabelaClassificadorLocal == CANDIDATURA_INSTRUMENTO_FINANCIAMENTO_TABLE_NAME) {
      result =await getCandidaturaInstrumentoFinanciamento();
      setShowDescricao(true)
    } else if (tabelaClassificadorLocal == DH_ESTADO_PROCESSO_TABLE_NAME) {
      result =await getEstadoProcesso();
      setShowDescricao(true)
    } else if (tabelaClassificadorLocal == AG_ESTADO_TABLE_NAME) {
      setShowDescricao(true)
      setShowDesignacao(true)
      result =await getAgEstado();
    }else if (tabelaClassificadorLocal == EA_ESTADO_TABLE_NAME) {
      result =await getAgEstado();
      setShowDesignacao(true)
     }else if (tabelaClassificadorLocal == DO_ESTADO_TABLE_NAME) {
      setShowDescricao(true)
      setShowDesignacao(true)
      result =await getDoEstado();
    }else if (tabelaClassificadorLocal == INT_PLANEAMENTO_NIVEL_1_TABLE_NAME) {
      result =await getIntPlaneamento1();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_PRIORIDADE_TABLE_NAME) {
      result =await getIntPrioridade();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_TIPO_INTERVENCAO_TABLE_NAME) {
      result =await getIntTipoIntervencao();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_INSTRUMENTO_PLANEAMENTO_ESTADO_TABLE_NAME) {
      result =await getIntIntrumentoPlaneamentoEstado();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_TIPO_INCIDENCIA_TABLE_NAME) {
      result =await getIntTipoIncidencia();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_TIPO_MOBILIZACAO_TABLE_NAME) {
      result =await getIntTipoMobilizacao();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_PALXXI_TIPO_NIVEL1_TABLE_NAME) {
      result =await getIntPalXXITipoNivel1();
      setShowDescricao(true)
      setShowSigla(true)
    }else if (tabelaClassificadorLocal == INT_PALXXI_TIPO_NIVEL2_TABLE_NAME) {
      result =await getIntPalXXITipoNivel2();
      setShowDescricao(true)
      setShowSigla(true)
      setIntPalXXITipoNivel1(true)
    }else if (tabelaClassificadorLocal == INT_PALXXI_TIPO_NIVEL3_TABLE_NAME) {
      result =await getIntPalXXITipoNivel3();
      setShowDescricao(true)
      setShowSigla(true)
      setIntPalXXITipoNivel1(true)
      setIntPalXXITipoNivel2(true)
    }else if (tabelaClassificadorLocal == INT_INSTRUMENTO_PLANEAMENTO_TABLE_NAME) {
      result =await getIntInstrumentoPlaneamento();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == INT_ACAO_FONTE_FINANCIAMENTO_TABLE_NAME) {
      result =await getIntAcaoFonteFinanciamento();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == MOB_OBJETIVO_NIVEL1_TABLE_NAME) {
      result =await getMobObjetivoNivel1();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == MOB_OBJETIVO_NIVEL2_TABLE_NAME) {
      result =await getMobObjetivoNivel2();
      setShowDescricao(true)
      setMobObjetivoNivel1(true)
    }else if (tabelaClassificadorLocal == MOB_TIPO_MANCHA_EMPRESTIMO_TABLE_NAME) {
      result =await getMobTipoManchaEmprestimo();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == DH_TIPO_PROCESSO_TABLE_NAME) {
      result =await getDhTipoProcesso();
      setShowDescricao(true) 
    }else if (tabelaClassificadorLocal == DH_FASES_PROCEDIMENTO_DELIMITACAO_TABLE_NAME) {
      result =await getDhFasesProcedimento();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == DH_TIPO_DOMINIO_TABLE_NAME) {
      result =await getDhTipoDominio();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == DH_LOCALIZACAO_PROCESSO_TABLE_NAME) {
      result =await getDhLocalizacaoProcesso();
      setShowDescricao(true)
    }else if (tabelaClassificadorLocal == DH_TIPO_SENTENCA_TABLE_NAME) {
      setShowDescricao(true)
      result =await getDhTipoSentença();
    }else if (tabelaClassificadorLocal == DH_CONDICIONANTES_PROCESSO_TABLE_NAME) {
      setShowDescricao(true)
      result =await getDhCondicionantesProcesso();
    }else if (tabelaClassificadorLocal == DH_TIPO_ACAO_JUDICIAL_TABLE_NAME) {
      setShowDescricao(true)
      result =await getDhTipoAcaoJudicial();
    }else if (tabelaClassificadorLocal == DH_TIPO_AQUISICAO_TABLE_NAME) {
      setShowDescricao(true)
      result =await getDhTipoAquisicao();
    }else if (tabelaClassificadorLocal == DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA_TABLE_NAME) {
      setShowDescricao(true)
      result =await getDhReconhecimentoPropriedadePrivada();
    }else if (tabelaClassificadorLocal == DH_TIPO_ACAO_RECONHECIMENTO_TABLE_NAME) {
      setShowDescricao(true)
      result = await getDhTipoAcaoReconhecimentos();
    }else if (tabelaClassificadorLocal == DH_TIPO_RECURSO_TABLE_NAME) {
      setShowDescricao(true)
      result = await getDhTipoRecurso();
    }else if (tabelaClassificadorLocal == DH_DECISAO_FINAL_TABLE_NAME) {
      setShowDescricao(true)
      result = await getDhTipoDecisaoFinal();
    }else if (tabelaClassificadorLocal == DH_TIPO_INICIATIVA) {
      setShowDescricao(true)
      result =await getDhTipoIniciativa();
    }else if (tabelaClassificadorLocal == DH_TIPO_LINHA_DEMARCACAO_TABLE_NAME) {
      setShowDescricao(true)
      result =await getDhTipoLinhaDemarcacao();
    } else if (tabelaClassificadorLocal == US_ESTADO_TITULO_TABLE_NAME) {
      result =await getUsEstadoTitulo();
      setShowDescricao(true) 
    }else if (tabelaClassificadorLocal == US_TIPO_PROCESSO_TABLE_NAME) {
      setShowNome(true)
      result =await getUsTipoProcesso();
    }else if (tabelaClassificadorLocal == US_TIPO_TITULO_TABLE_NAME) {
      setShowNome(true)
      result =await getUsTipoTitulo();
    }else if (tabelaClassificadorLocal == US_TIPO_UTILIZACAO_TABLE_NAME) {
      setShowNome(true)
      result =await getUsTipoUtilizacao();
    }else if (tabelaClassificadorLocal == AG_TIPO_PRETENSAO_TABLE_NAME) {
      setShowDescricao(true)
      result =await getAgTipoPretensao();
    }else if (tabelaClassificadorLocal == AG_DECISAO_TABLE_NAME) {
      setShowDescricao(true)
      result =await getAgDecisao();
    }else if (tabelaClassificadorLocal == AG_TEMA_TABLE_NAME) {
      setShowDescricao(true)
      result =await getAgtema();
    }else if (tabelaClassificadorLocal == DI_TIPO_ENTIDADE_TABLE_NAME) {
      setShowDesignacao(true)
      result =await getDiTipoEntidade();
    }else if (tabelaClassificadorLocal == DO_TIPO_ACESSO_TABLE_NAME) {
      setShowDescricao(true)
      setShowDesignacao(true)  
      result =await getDoTipoAcesso();
    }else if (tabelaClassificadorLocal == DO_TIPO_RECURSO_TABLE_NAME) {
      setShowDescricao(true)
      setShowDesignacao(true)
      result =await getDoTipoRecurso();
    }else if (tabelaClassificadorLocal == MO_MODELO_SUBTIPO_TABLE_NAME) {
      setShowDescricao(true)
      setShowDesignacao(true)
      result = await getSpecificColumnsMoSubTipo(); 
    }else if (tabelaClassificadorLocal == GV_TEMA_TABLE_NAME){
      setShowDescricao(true)
      result = await getGvTema();
    }else if (tabelaClassificadorLocal == GV_SUB_TEMA_TABLE_NAME){
      setShowGvSubTema(true)
      result = await getGv_SubTema();
    }else if (tabelaClassificadorLocal == MDT_SELECTION_NAME) {
      result = await getMDTs();
      setShowDescricao(true);     
      setShowUploadDocumentos(true);
      setGravarDisabled(true);
      setShowNome(true);
      setShowTipo(true);
      setshowDataVoo(true);
      setNomeDisabled(true);
      setShowDesignacao(true);
    }
    
    if (result) {
      setData(result);
    }
    postMessage({ type: 'hideLoader' }, '*')
  }

  const registarNovoClick = () => {
    setShowDialog(true);
    setNovoRegisto(true);
    clearFieldsClassificador();
    setEdit(false)
  }

  const onChangeIdField = (e: any) => {
    setIdField(e.value);
  }
 
  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

  };

  const optionsMais = [
    {
      key: 'novoRegisto',
      text: 'Nova entidade',
      elementType: 'button',
      className: 'icon-siarl icon-registar btnIconRegistar'
    }
  ]

  const [edit, setEdit] = useState(false);


  const getTemaBySubtemaId = (idSubTema: number) => get(`${GET_GV_PESQUISA_ID_SUB_TEMAS}/${idSubTema}`);
  const getMobObjetivoNivel1ById = (id: number) => get(`${GET_MOB_OBJETIVO_NIVEL_1_BY_ID}/${id}`);
  const getIntPalXXITipoNivel1ById = (id: number) => get(`${GET_INT_PALXXI_TIPO_NIVEL_1_BY_ID}/${id}`);
  const getIntPalXXITipoNivel2ById = (id: number) => get(`${GET_INT_PALXXI_TIPO_NIVEL_2_BY_ID}/${id}`);

  const gridRowClick = async (e: any) => {
    console.log(e.dataItem);

    setNovoRegisto(false);
    setIdField(e.dataItem.id);
    setDesignacaoField(e.dataItem.designacao);
    setDescricaoField(e.dataItem.descricao);
    setSiglaField(e.dataItem.sigla);
    setNomeField(e.dataItem.nome);
    setEmailField(e.dataItem.email);
    setUserIdField(e.dataItem.user_id);
    setTipoField(e.dataItem.tipo);
    
    const idSubTema = e.dataItem.id;
    const idMobObjetivoNivel1 = e.dataItem.id_int_mob_objetivo_dep_nivel_1;

    const idPalXXITipoNivel1 = e.dataItem.id_int_palXXI_tip_nivel1;
    const idPalXXITipoNivel2 = e.dataItem.id_int_palXXI_tip_nivel2;

    if (idSubTema) {
        try {
            const tema = await getTemaBySubtemaId(idSubTema);
            //console.log("Tema retornado:", tema); // Adicione este log para verificar
            if (tema) {
                setGvTemaField(tema);
            } else {
                setGvTemaField(null);
            }
        } catch (error) {
            console.error('Erro ao buscar o tema:', error);
            setGvTemaField(null);
        }
    } else {
        console.error('idSubTema não encontrado na dataItem');
        setGvTemaField(null);
    }

    if (idMobObjetivoNivel1) {
      try {
        const objetivoNivel1 = await getMobObjetivoNivel1ById(idMobObjetivoNivel1);

        if (objetivoNivel1) {
          setMobObjetivoNivel1Field(objetivoNivel1);
        } else {
          setMobObjetivoNivel1Field(null);
        }
      } catch (error) {
        console.error("Erro ao buscar o objetivo nível 1:", error);
        setMobObjetivoNivel1Field(null);
      }
    } else {
      console.error("idMobObjetivoNivel1 não encontrado na dataItem");
      setMobObjetivoNivel1Field(null);
    }

    //  INT_PALXXI_TIPO_NIVEL
    if (idPalXXITipoNivel1) {
      try {
        const palXXITipoNivel1 = await getIntPalXXITipoNivel1ById(idPalXXITipoNivel1);

        if (palXXITipoNivel1) {
          setintPalXXITipoNivel1Field(palXXITipoNivel1);
        } else {
          setintPalXXITipoNivel1Field(null);
        }
      } catch (error) {
        console.error("Erro ao buscar o objetivo nível 1:", error);
        setintPalXXITipoNivel1Field(null);
      }
    } else {
      console.error("idMobObjetivoNivel1 não encontrado na dataItem");
      setintPalXXITipoNivel1Field(null);
    }

    if (idPalXXITipoNivel2) {
      try {
        const palXXITipoNivel2 = await getIntPalXXITipoNivel2ById(idPalXXITipoNivel2);

        if (palXXITipoNivel2) {
          setintPalXXITipoNivel2Field(palXXITipoNivel2);
        } else {
          setintPalXXITipoNivel2Field(null);
        }
      } catch (error) {
        console.error("Erro ao buscar o objetivo nível 1:", error);
        setintPalXXITipoNivel2Field(null);
      }
    } else {
      console.error("idMobObjetivoNivel1 não encontrado na dataItem");
      setintPalXXITipoNivel2Field(null);
    }

    if (hasClassificador) {
      setShowDialog(true);
    }
    setEdit(true);
  }

  const [percentTop, setPercentTop] = useState("3%");

  const gravar = async (e:any) => {
    if (!idField) {
    if (fileField == undefined || fileField.length === 0) {

      postMessage({ type: 'errorMsg', value: { top: (isMobile? (Number(percentTop.split('%')[0])-5)+'%' : percentTop) , message: "Carregue o MDT." } }, '*');
      return;
    }
  }


    setShowGravar(false);
    setShowPesquisar(true);
    if (tabelaClassificador == MO_MODELOS_TIPO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertModeloTipo(objToSend);
      }
      else {
        await updateModeloTipo(objToSend);
      }
    }

    if (tabelaClassificador == OC_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        await insertOcEstado(objToSend);
      }
      else {
        await updateOcEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == MO_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertMoEstado(objToSend);
      }
      else {
        await updateMoEstado(objToSend);
      }
    }
    if (tabelaClassificador == INT_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertIntEstado(objToSend);
      }
      else {
        await updateIntEstado(objToSend);
      }
    }

    if (tabelaClassificador == ACAO_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAcaoEstado(objToSend);
      }
      else {
        await updateAcaoEstado(objToSend);
      }
    }

    if (tabelaClassificador == ACAO_CONTRATACAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAcaoContratacao(objToSend);
      }
      else {
        await updateAcaoContratacao(objToSend);
      }
    }

    if (tabelaClassificador == ACAO_TIPO_ENGENHARIA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAcaoTipoEngenharia(objToSend);
      }
      else {
        await updateAcaoTipoEngenharia(objToSend);
      }
    }

    if (tabelaClassificador == ACAO_TIPO_NATUREZA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAcaoTipoNatureza(objToSend);
      }
      else {
        await updateAcaoTipoNatureza(objToSend);
      }
    }

    if (tabelaClassificador == ACAO_COMPONENTE_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAcaoComponente(objToSend);
      }
      else {
        await updateAcaoComponente(objToSend);
      }
    }

    if (tabelaClassificador == ACAO_TIPO_PLANEAMENTO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAcaoTipoPlaneamento(objToSend);
      }
      else {
        await updateAcaoTipoPlaneamento(objToSend);
      }
    }

    if (tabelaClassificador == MOBILIZACAO_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertMobilizacaoEstado(objToSend);
      }
      else {
        await updateMobilizacaoEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == CANDIDATURA_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertCandidaturaEstado(objToSend);
      }
      else {
        await updateCandidaturaEstado(objToSend);
      }
    }

    if (tabelaClassificador == CANDIDATURA_INSTRUMENTO_FINANCIAMENTO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertCandidaturaInstrumentoFinanciamento(objToSend);
      }
      else {
        await updateCandidaturaInstrumentoFinanciamento(objToSend);
      }
    }
    
    if (tabelaClassificador == DH_ESTADO_PROCESSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        await insertUsTituloEstado(objToSend);
      }
      else {
        await updateUsTituloEstado(objToSend);
      }
    }

    if (tabelaClassificador == US_ESTADO_TITULO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        await insertUsTituloEstado(objToSend);
      }
      else {
        await updateUsTituloEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == AG_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        objToSend['id'] = undefined;
        await insertAgEstado(objToSend);
      }
      else {
        await updateAgEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == EA_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        objToSend['id'] = undefined;
        await insertEaEstado(objToSend);
      }
      else {
        await updateEaEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == DO_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        await insertDoEstado(objToSend);
      }
      else {
        await updateDoEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == INT_PLANEAMENTO_NIVEL_1_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertIntPlaneamento1(objToSend);
      }
      else {
        await updateIntPlaneamento1(objToSend);
      }

    }
    
    if (tabelaClassificador == INT_PRIORIDADE_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertIntPrioridade(objToSend);
      }
      else {
        await updateIntPrioridade(objToSend);
      }
    }
    
    if (tabelaClassificador == INT_TIPO_INTERVENCAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertIntTipoIntervencao(objToSend);
      }
      else {
        await updateIntTipoIntervencao(objToSend);
      }
    }
    
    if (tabelaClassificador == INT_INSTRUMENTO_PLANEAMENTO_ESTADO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertIntInstrumentoPlaneamentoEstado(objToSend);
      }
      else {
        await updateIntInstrumentoPlaneamentoEstado(objToSend);
      }
    }
    
    if (tabelaClassificador == INT_TIPO_INCIDENCIA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        await insertIntTipoIncidencia(objToSend);
      }
      else {
        await updateIntTipoIncidencia(objToSend);
      }
    }
    
    if (tabelaClassificador == INT_TIPO_MOBILIZACAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertIntTipoMobilizacao(objToSend);
      }
      else {
        await updateIntTipoMobilizacao(objToSend);
      }
    }

    if (tabelaClassificador == INT_PALXXI_TIPO_NIVEL1_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined,
        sigla: siglaField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertIntPalXXITipoNivel1(objToSend);
      }
      else {
        await updateIntPalXXITipoNivel1(objToSend);
      }
    }

    if (tabelaClassificador == INT_PALXXI_TIPO_NIVEL2_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined,
        sigla: siglaField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertIntPalXXITipoNivel2(objToSend);
      }
      else {
        await updateIntPalXXITipoNivel2(objToSend);
      }
    }

    if (tabelaClassificador == INT_PALXXI_TIPO_NIVEL3_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined,
        sigla: siglaField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertIntPalXXITipoNivel3(objToSend);
      }
      else {
        await updateIntPalXXITipoNivel3(objToSend);
      }
    }

    if (tabelaClassificador == INT_INSTRUMENTO_PLANEAMENTO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField ?? undefined,
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertIntInstrumentoPlaneamento(objToSend);
      }
      else {
        await updateIntInstrumentoPlaneamento(objToSend);
      }
    }

    if (tabelaClassificador == INT_ACAO_FONTE_FINANCIAMENTO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertIntAcaoFonteFinanciamento(objToSend);
      }
      else {
        await updateIntAcaoFonteFinanciamento(objToSend);
      }
    }
    
    if (tabelaClassificador == MOB_OBJETIVO_NIVEL1_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertMobObjetivoNivel1(objToSend);
      }
      else {
        await updateMobObjetivoNivel1(objToSend);
      }
    }

    if (tabelaClassificador == MOB_OBJETIVO_NIVEL2_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined,
        id_int_mob_objetivo_dep_nivel_1: mobObjetivoNivel1Field.id,
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertMobObjetivoNivel2(objToSend);
      }
      else {
        await updateMobObjetivoNivel2(objToSend);
      }
    }

    if (tabelaClassificador == MOB_TIPO_MANCHA_EMPRESTIMO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }


        await insertMobTipoManchaEmprestimo(objToSend);
      }
      else {
        await updateMobTipoManchaEmprestimo(objToSend);
      }
    }

    if (tabelaClassificador == DH_TIPO_PROCESSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoProcesso(objToSend);
      }
      else {
        await updateDhTipoProcesso(objToSend);
      }
    }
    
    if (tabelaClassificador == DH_FASES_PROCEDIMENTO_DELIMITACAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhFasesProcedimento(objToSend);
      }
      else {
        await updateDhFasesProcedimento(objToSend);
      }
    }
    
    if (tabelaClassificador == DH_TIPO_DOMINIO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoDominio(objToSend);
      }
      else {
        await updateDhTipoDominio(objToSend);
      }
    }
    
    if (tabelaClassificador == DH_LOCALIZACAO_PROCESSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        
        await insertDhLocalizacaoProcesso(objToSend);
      }
      else {
        await updateDhLocalizacaoProcesso(objToSend);
      }
    }
    
    if (tabelaClassificador == DH_TIPO_SENTENCA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoSentença(objToSend);
      }
      else {
        await updateDhTipoSenteça(objToSend);
      }
    }

      if (tabelaClassificador == DH_CONDICIONANTES_PROCESSO_TABLE_NAME) {
        const objToSend = {
          id: idField,
          descricao: descricaoField ?? undefined
        }
        if (novoRegisto) {
          if (!idField) {
            postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
            return;
          }
          for(let i=0; i<= data.length; i++) {
            const dataObj: any = data[i];
            if (dataObj?.id == idField) {
              postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
              return;
            }
          }

          await insertDhCondicionantesProcesso(objToSend);
        }
        else {
          await updateDhCondicionantesProcesso(objToSend);
        } 
    }

    if (tabelaClassificador == DH_TIPO_ACAO_JUDICIAL_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoAcaoJudicial(objToSend);
      }
      else {
        await updateDhTipoAcaoJudicial(objToSend);
      }
    }

    if (tabelaClassificador == DH_TIPO_AQUISICAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDHTipoAquisicao(objToSend);
      }
      else {
        await updateDhTipoAquisicao(objToSend);
      }
    }

    if (tabelaClassificador == DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhReconhecimentoPropriedadePrivada(objToSend);
      }
      else {
        await updateDhReconhecimentoPropriedadePrivada(objToSend);
      }
    }

    if (tabelaClassificador == DH_TIPO_ACAO_RECONHECIMENTO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoAcaoReconhecimentos(objToSend);
      }
      else {
        await updateDhTipoAcaoReconhecimentos(objToSend);
      }
    }

    if (tabelaClassificador == DH_TIPO_RECURSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoRecurso(objToSend);
      }
      else {
        await updateDhTipoRecurso(objToSend);
      }
    }

    if (tabelaClassificador == DH_DECISAO_FINAL_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoDecisaoFinal(objToSend);
      }
      else {
        await updateDhTipoDecisaoFinal(objToSend);
      }
    }

    if (tabelaClassificador == DH_TIPO_INICIATIVA) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoIniciativa(objToSend);
      }
      else {
        await updateDhtipoIniciativa(objToSend);
      }
    }
    if (tabelaClassificador == DH_TIPO_LINHA_DEMARCACAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDhTipoLinhaDemarcacao(objToSend);
      }
      else {
        await updateDhTipoLinhaDemarcacao(objToSend);
      }
    }
    
    if (tabelaClassificador == US_TIPO_PROCESSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        nome: nomeField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertUsTipoProcesso(objToSend);
      }
      else {
        await updateUsTipoProcesso(objToSend);
      }
    }

    if (tabelaClassificador == US_TIPO_TITULO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        nome: nomeField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertUsTipoTitulo(objToSend);
      }
      else {
        await updateUsTipoTitulo(objToSend);
      }
    }

    if (tabelaClassificador == US_TIPO_UTILIZACAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        nome: nomeField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertUsTipoUtilizacao(objToSend);
      }
      else {
        await updateUsTipoUtilizacao(objToSend);
      }
    }
    
    if (tabelaClassificador == AG_TIPO_PRETENSAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAgTipoPretensao(objToSend);
      }
      else {
        await updateAgTipoPretensao(objToSend);
      }
    }
    
    if (tabelaClassificador == AG_DECISAO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAgDecisao(objToSend);
      }
      else {
        await updateAgDecisao(objToSend);
      }
    }
    
    if (tabelaClassificador == AG_TEMA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertAgTema(objToSend);
      }
      else {
        await updateAgTema(objToSend);
      }
    }
    
    if (tabelaClassificador == DI_TIPO_ENTIDADE_TABLE_NAME) {
      const objToSend = {
        id: idField,
        designacao: designacaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDiTipoEntidade(objToSend);
      }
      else {
        await updateDiTipoEntidade(objToSend);
      }
    }
    
    if (tabelaClassificador == DO_TIPO_ACESSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined,
        designacao: designacaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertDoTipoAcesso(objToSend);
      }
      else {
        await updateDoTipoAcesso(objToSend);
      }
    }
    
    if (tabelaClassificador == DO_TIPO_RECURSO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField ?? undefined,
        designacao: designacaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }   

        await insertDoTipoRecurso(objToSend);
      }
      else {
        await updateDoTipoRecurso(objToSend);
      }
    }
    
    if (tabelaClassificador == MO_MODELO_SUBTIPO_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField,
        designacao: designacaoField ?? undefined
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }

        await insertMoSubTipoModelo(objToSend);
      }
      else {
        await updateMoSubTipoModelo(objToSend);
      }
    }
    if (tabelaClassificador == GV_TEMA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField,
      }
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        await insertGvTema(objToSend);
      }
      else {
        await updateGvTema(objToSend);
      }
    }

    if (tabelaClassificador == GV_SUB_TEMA_TABLE_NAME) {
      const objToSend = {
        id: idField,
        descricao: descricaoField,
      };

      const objToUpdate = {
        id: idField,
        descricao: descricaoField, 
        id_tema: gvTemaField.id
      };
  
      if (novoRegisto) {
        if (!idField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o id"}});
          return;
        }
        for(let i=0; i<= data.length; i++) {
          const dataObj: any = data[i];
          if (dataObj?.id == idField) {
            postMessage({type: "errorMsg", value: {message: "O id ja existe"}}, "*");
            return;
          }
        }
        if (!gvTemaField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o 'Geovisualizador Tema"}});
          return;
        }
        
        const response = await insertGv_SubTema(objToSend);
  
        if (response) {
          postMessage({ type: "successMsg", value: { message: "Subtema inserido com sucesso!" } });
  
          if (gvTemaField) {
            const associacaoObj = {
              id_tema: gvTemaField.id,
              id_sub_tema: response.id
            };
            await insertAssociacaoSubTema(associacaoObj);
          }
          } else {
            postMessage({ type: "errorMsg", value: { message: "Erro ao inserir subtema." } });
          }
      } else {
        if (!gvTemaField) {
          postMessage({type: "infoMsg", value: {message: "Preencha o 'Geovisualizador Tema"}});
          return;
        }
        const response = await updateAssociacaoSubTema(objToUpdate);
  
        if (response) {
          postMessage({ type: "successMsg", value: { message: "Subtema atualizado com sucesso!" } });
        } else {
          postMessage({ type: "errorMsg", value: { message: "Erro ao atualizar subtema." } });
        }
      }
    }

    if (tabelaClassificador == MDT_SELECTION_NAME) {
      console.log(MDT_SELECTION_NAME);
      if (!idField) {
      const nomeArquivo = fileField[0].name;

      const exists = await mdtNameExists(nomeArquivo);

      if (exists) {
        postMessage({type: "infoMsg", value: { message: "Já existe um ficheiro com esse nome." }}, "*");
        return;
      }
    
      const id_mdt = await insertMdt({
        tipo: tipoField,
        designacao: designacaoField,
        descricao: descricaoField,
        data: dataField,
        densidade: densidadeField
      });      
      const formData = new FormData();
      formData.append("mdt", fileField[0].getRawFile());
      formData.append("id_mdt", id_mdt);
      postMessage({type: "showLoader"}, "*");
      const cgmdt = await uploadMdt(formData);
      processMdt(cgmdt.id);
      postMessage({type: "sucessMsg", value: "Classificador gravado, aguarde o processamento..."}, "*");
      const intervalId = setInterval(async() => {
        const mdt = await getMDT(cgmdt.id);
        if (mdt.data_fim_processamento) {
          clearInterval(intervalId);
          postMessage({type: "hideLoader"}, "*");
          setShowDialog(false);
          refreshGrid(tabelaClassificador);
        }
      }, 10000);
    } else {
      const objectToSend = {
        id : idField,
        tipo: tipoField,
        designacao: designacaoField,
        descricao: descricaoField,
        data: dataField,
        densidade: densidadeField
      }

      await updateMdt(objectToSend);
      postMessage({type: "sucessMsg", value: "Classificador gravado"}, "*");
      setShowDialog(false);
      refreshGrid(tabelaClassificador);
    }
    console.log(e);
    } else 
    {
      refreshGrid(tabelaClassificador);
      postMessage({type: "sucessMsg", value: "Classificador gravado"}, "*");
      setShowDialog(false);
      refreshGrid(tabelaClassificador);
    }
    
  }

  const clearFieldsClassificador = () => {
    setIdField('');
    setDesignacaoField('');
    setDescricaoField('');
    setSiglaField('');
    setNomeField('');
    setTipoField('');
    setDataField(undefined);
    setFileField(undefined);
    setGvTemaField(null);
    setMobObjetivoNivel1Field(null);
    setintPalXXITipoNivel1Field(null);
    setintPalXXITipoNivel2Field(null);
  }

  const limparPesquisa = (e: any, formRenderProps:FormRenderProps) => {
    refreshGrid(e?.value?.tabela);
    formRenderProps.onChange('tipoClassificador', { value: null })
  }

  const [hasClassificador, sethasClassificador] = useState(false);

  const tipoClassificadorChange = (e: any) => {
    sethasClassificador(true);
    clearFieldsClassificador();
    refreshGrid(e?.value?.tabela);
    setShowRenderizaNovoRegisto(true)
  }

  const onAddUpload = (e: any) => {
    setFileField(e.affectedFiles);
    console.log(e);
  }

  const onProgressHandler = (event: UploadOnProgressEvent) => {
    setFileField(event.newState);
  }

  const onChangeUpload = (e: any) => {
    console.log(e);
  }

  const onRemoveUpload = (e: UploadOnRemoveEvent) => {
    const updatedFiles = fileField.filter((file: { uid: string }) => file.uid !== e.affectedFiles[0].uid);
    setFileField(updatedFiles);
    console.log(e);
  }

  const openAjuda = () => {
    window.open(URL_AJUDA_BACKOFFICE_CLASSIFICADORES, "_blank")
  }


  const TipoCalculo = ["MDS", "MDT"];

  const handleChange = (event: DropDownListChangeEvent) => {
    setTipoField(event.target.value);
  };

  return (
    <div className={styles.base}>

      <div className={styles.header}>

        <div>
          <div className={styles.nomeDoModulo}>
            Classificadores
          </div>
          <div className={styles.tituloDaPagina}>
            Classificadores
          </div>
        </div>

        <div>
        {showRenderizaNovoRegisto && (

          <Button onClick={registarNovoClick} className={styles.btnNovoRegisto}
          style={{ display: isMobile ? 'none' : '' }}
          id='novoRegisto' title='Novo Registo'>
            <span className="icon-siarl icon-registar btnIconRegistar"></span>{' '}
            &nbsp;{' '}
            Novo Registo
          </Button>
        
          )}
          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
            <span className="icon-siarl icon-ajuda"></span>
          </button>

          <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
            <span className="icon-siarl icon-minimizar"></span>
          </button>

        </div>
      </div>
        <Form
          onSubmitClick={handleSubmit}
          render={(formRenderProps: FormRenderProps) => (
            <>
            <div className={`${styles.form} ${styles.removeScrollDuplicado}`}>
              <FormElement >
                
                <fieldset>

                  <legend>
                    <span className={styles.fieldsetTitulo}>Classificadores</span>
                  </legend>
                  <div className={styles.espacoVerticalFieldSet}>

                    <div className={styles.fields}>
                      <Field
                        name="tipoClassificador"
                        label="Classificador"
                        data={classificadores}
                        onChange={tipoClassificadorChange}
                        component={ComboBox}
                        textField="descricao"
                      />
                    </div>
                  </div>
                </fieldset>
              </FormElement>

              <div>
                <Grid
                  className={styles.customGrid}
                  style={{cursor: 'pointer'}} 
                  onRowClick={gridRowClick}
                  data={data}
                />   
              </div>
            </div>
              <div className={`${styles.footer} ${styles.justify_multiple_children}`}>
                <Button
                  onClick={(e: any) => {limparPesquisa('', formRenderProps)}}
                  className={styles.btnLimparPesquisa}
                  title='Limpar pesquisa'
                >
                  <span className="icon-siarl icon-limparcampos"></span>
                  <span className={styles.rotulo}>
                    {' '}&nbsp;{' '}
                    Limpar pesquisa
                  </span>
                </Button>
                <Button
                  onClick={formRenderProps.onSubmit}
                  className={styles.btnPesquisar}
                  title='Pesquisar'
                >
                  <span className="icon-siarl icon-pesquisar"></span>
                  <span className={styles.rotulo}>
                    {' '}&nbsp;{' '}
                    Pesquisar
                  </span>
                </Button>
                
              </div>
            </>
          )}
        />
        {showDialog ? 
          <Dialog className={`ModalDocumentos  ${styles.removeScrollDuplicado}`} onClose={() => {
            setShowDialog(false)
          }}>
            <div>
              <Input
                name="Id"
                label="Id"
                value={idField}
                onChange={onChangeIdField}
                disabled={edit}
              />
            </div>

            <div> 
              {showDesignacao && (
              <Input
                name="designacao"
                label="Designação"
                style={{ width: '100%' }}
                onChange={(e: any) => {
                  setDesignacaoField(e.value);
                }}
                value={designacaoField}
              />
              )}

              {showDescricao && (
                <Input
                  name="descricao"
                  label="Descrição"
                  style={{ width: '100%' }}
                  disabled={descricaoDisabled}
                  onChange={(e: any) => {
                    setDescricaoField(e.value);
                  }}
                  value={descricaoField}
                />
              )}

              {showSigla && (
                <Input
                  name="sigla"
                  label="Sigla"
                  style={{ width: '100%' }}
                  disabled={siglaDisabled}
                  onChange={(e: any) => {
                    setSiglaField(e.value);
                  }}
                  value={siglaField}
                />
              )}

              {showNome && (
                <Input
                  name="nome"
                  label="Nome"
                  disabled={nomeDisabled}
                  style={{ width: '100%' }}
                  onChange={(e: any) => {
                    setNomeField(e.value);
                  }}
                  value={nomeField}
                />
              )}

              {showUserId && (
            <Input
              name="userId"
              label="Utilizador Id"
              style={{ width: '100%' }}
              onChange={(e: any) => {
                setUserIdField(e.value);
              }}
              value={userIdField}
            />
              )}

              {showEmail && (
                <Input
                  name="email"
                  label="Email"
                  style={{ width: '100%' }}
                  onChange={(e: any) => {
                    setEmailField(e.value);
                  }}
                  value={emailField}
                />
              )} 

              {showTipo && (
                <DropDownList
                  name="tipo"
                  label="Tipo"
                  data={TipoCalculo}
                  value={tipoField}
                  onChange={handleChange}
                  style={{width: '100%'}}
                />
              )}

              {showDataVoo && (
                  <DateTimePicker
                    name="data"
                    label="Data"
                    onChange={(e: any) => {
                      setDataField(e.value);
                    }}
                    value={dataField}
                  />
              )}

              {showUploadDocumentos ?
                <Upload
                  autoUpload={true}
                  showActionButtons={false}
                  multiple={true}
                  files={fileField}
                  restrictions={{
                    allowedExtensions: [".tif"],
                  }}
                  onAdd={onAddUpload}
                  onRemove={onRemoveUpload}
                  onProgress={onProgressHandler}
                />
              : '' }

              {showGvSubTema ?
                <>
                  <DropDownList
                    name="tema"
                    label="Geovisualizador Tema"
                    data={GvTemaData}
                    textField="descricao" 
                    value={gvTemaField}
                    onChange={(e) => setGvTemaField(e.value)}
                    style={{ width: '100%' }}
                  />
                  <Input
                    name="descricao"
                    label="Geovisualizador Subtema"
                    style={{ width: '100%' }}
                    disabled={descricaoDisabled}
                    onChange={(e: any) => {
                      setDescricaoField(e.value)
                    } }
                    value={descricaoField}
                  />
                </>
              : '' }

              {showMobObjetivoNivel1 ?
                <DropDownList
                  name="objetivoNivel1"
                  label="Objetivo Nível 1"
                  data={MobObjetivoNivel1Data}
                  textField="descricao" 
                  value={mobObjetivoNivel1Field}
                  onChange={(e) => setMobObjetivoNivel1Field(e.value)}
                  style={{ width: '100%' }}
                />
              : '' }

              {showIntPalXXITipoNivel1 ?
                <DropDownList
                  name="palXXITipoNivel1"
                  label="PalXXI Tipo Nível 1"
                  data={IntPalXXITipoNivel1Data}
                  textField="descricao" 
                  value={intPalXXITipoNivel1Field}
                  onChange={(e) => setintPalXXITipoNivel1Field(e.value)}
                  style={{ width: '100%' }}
                />
              : '' }

              {showIntPalXXITipoNivel2 ?
                <DropDownList
                  name="palXXITipoNivel2"
                  label="PalXXI Tipo Nível 2"
                  data={IntPalXXITipoNivel2Data}
                  textField="descricao" 
                  value={intPalXXITipoNivel2Field}
                  onChange={(e) => setintPalXXITipoNivel2Field(e.value)}
                  style={{ width: '100%' }}
                />
              : '' }
            </div>
            
            <div className="footerModal justify_multiple_children">
              <Button
                type={"submit"}
                onClick={() => {
                  setShowDialog(false);
                }}
                className='btnLimparPesquisa'
                title="Fechar"
              >
                <span className="icon-siarl icon-fechar btnIconRegistar"></span> &nbsp;{' '}
                Cancelar
              </Button>

              <Button
                type={"submit"}
                onClick={remover}

                className='btnLimparPesquisa'
                title="Remover"
              >
                <span className="icon-siarl icon-descartar btnIconRegistar"></span> &nbsp;{' '}
                Remover
              </Button>
              
              <Button
                type={"submit"}
                onClick={gravar}
                className={styles.btnGravar}
                title="Gravar"
              >
                  <span className="icon-siarl icon-submeter btnIconRegistar"></span> &nbsp;{' '}
                  Gravar
              </Button>

            </div>
          </Dialog>
    : ''}
    </div>
    
  )
}
